
  (function () {
    // ========================================================================
    // CONFIGURATION & DATA
    // ========================================================================
    const CLERK_PUBLISHABLE_KEY = 'pk_live_Y2xlcmsuZ3JvdXBoaWl0LmNvbSQ';
    const AMPLITUDE_API_KEY = '62cdc342effcebc66e69e28d9059688a';
    //const REVENUECAT_PUBLIC_KEY = 'rcb_jEKDZnZpEOricaIEYERcQqNqzYAq';
    const REVENUECAT_PUBLIC_KEY = 'strp_XGINatsluLMGTfCXFdoBiNWPFeX';
    const SHOPIFY_STORE_URL = 'www.grouphiit.com';
    const SHOPIFY_HSA_VARIANT_ID = '40237750255710';

    const RC_INDIVIDUAL_OFFERING_ID = 'web';
    const RC_GROUP_OFFERING_ID = 'group_web';

    const RC_PACKAGE_MAP = {
      individual: {
        annual:  '$rc_annual',
        monthly: '$rc_monthly',
      },
      group: {
        group_family_monthly:   '$rc_monthly_1',
        group_family_annual:    '$rc_annual_3',  
        group_growth_monthly:   '$rc_monthly_2', 
        group_growth_annual:    '$rc_annual_2',  
        group_business_monthly: '$rc_monthly_3',
        group_business_annual:  '$rc_annual_1',  
      },
    };

    

    const SUCCESS_REDIRECT_URL = `https://${SHOPIFY_STORE_URL}/pages/thank-you`;
    const SOCIAL_PROOF_TEXT = 'OVER 30 MILLION WORKOUTS COMPLETED WORLDWIDE';
    const REVIEWS_COUNT = '900+ Five-Star Reviews';

    // ========================================================================
    // TRANSLATION DATA
    // ========================================================================
    const TRANSLATIONS = {
      en: {
        alreadyMember: "Already a member?",
        logIn: "Log in",
        upgradeWarning: "Note: You already have an Individual plan. Starting this Group plan will create a separate subscription. Please manage your old plan in the portal after checkout.",
        headline: 'Workouts for your whole crew.',
        subhead: 'Unlock unlimited access to all classes. Join the global movement for better health.',
        forMyself: 'For Myself',
        forMyGroup: 'For My Group',
        startTrial: 'Start My Trial',
        loggedInAs: 'Logged in as:',
        logOut: 'Log out',
        whatsIncluded: "What's Included",
        safeCheckout: 'Guaranteed Safe Checkout',
        monthly: 'Monthly',
        annual: 'Annual',
        year: 'yr',
        month: 'mo',
        billed: 'Billed',
        billedYearlyInd: 'Billed Annually',
        billedYearlyGrp: 'Billed Annually',
        billedMonthly: 'Billed Monthly',
        members: 'members',
        seatMonthly: 'seat monthly',
        equivalent: 'mo equivalent',
        hsaTitle: 'Pay with HSA/FSA Card',
        hsaDesc: 'Select "TrueMed" at checkout for one-time charge.',
        checkoutNow: 'Checkout Now',
        contactSales: 'Contact Sales',
        enterpriseTitle: 'Enterprise, Schools & Gyms',
        enterpriseDesc: 'Custom bulk licensing, SSO/SAML and specialized display rights.',
        stepActivation: 'Activation',
        stepVerification: 'Verification',
        stepAccess: 'Access',
        setupOrganization: 'Set Up Group',
        createOrganization: 'Create your group to continue with group checkout. You can change your group name later.',
        organizationDetected: 'Your group is ready.',
        continueCheckout: 'Continue to Checkout',
        organizationRequired: 'Please create or join a group before checkout.',
        welcomeBack: 'Welcome Back',
        continueNext: 'Continue to Next Step',
        notYou: 'Not you? Log out',
        createAccount: 'Create your account to continue.',
        redirecting: 'Redirecting to Secure Checkout...',
        secureSSL: 'Secure SSL Connection',
        proceedCheckout: 'Proceed to Checkout',
        personalizing: 'Personalizing Experience',
        skipSurvey: 'Skip Survey',
        accessGranted: 'Access Granted!',
        syncing: 'Synchronizing your account. Redirecting...',
        returnStep: 'Return to previous step',
        cancel: 'Cancel',
        savingAnnual: 'GET 5 MONTHS FREE',
        savingAnnualGroup: 'GET 2 MONTHS FREE',
        individualMembership: 'Individual Membership',
        groupAccess: 'Group Access',
        creatingFor: 'Creating membership for:',
        managingGroupMembership: 'You are currently managing the group membership.',
        activeIndividualMembership: 'You already have an active individual membership! Thank you for being a part of the community.',
        manageMembership: 'Manage Membership',
        activeBothMembership: 'You currently have active Individual and Group memberships. Please manage your billing to avoid duplicate charges.',
        expiredAdminMessage: "Your group <strong>{{groupName}}</strong> has an expired subscription. You can update your billing to restore access, or delete this group if you wish to start a new one.",
        manageGroupBtn: "Manage Group",
        expiredMemberMessage: "You are currently a member of the group <strong>{{groupName}}</strong>. To purchase a new Group membership and start your own group, you must first leave your current group.",
        manageAccountBtn: "Manage Account",
        localCurrencyNote: 'Your local currency and applicable taxes are calculated at checkout.',


        p_annual_name: 'Annual Membership',
        p_monthly_name: 'Monthly Membership',
        p_family_name: 'Family Plan',
        p_family_desc: 'Perfect for households, pods, and small teams.',
        p_growth_name: 'Growth Plan',
        p_growth_desc: 'Great for scaling teams and mid-size groups.',
        p_business_name: 'Business Plan',
        p_business_desc: 'Ideal for growing companies. Invite employees and their families.',

        f_i_1: 'Reach your goals with 1000+ HIIT, Strength, Yoga & Mobility Classes',
        f_i_2: 'Watch on iOS, Desktop, Roku & Chromecast',
        f_i_3: 'Play your own music or watch TV while exercising',
        f_i_4: 'Follow day by day training programs for all levels',
        f_i_5: 'Online account management, cancel anytime.',
        f_g_1: 'Everything in Individual plans',
        f_g_2: 'Centralized Group Billing & Admin',
        f_g_3: 'Simple member invites and management',
        f_g_4: 'Priority Group support',
        f_g_5: 'Office gym display & streaming rights',
        f_g_6: 'Online account management, cancel anytime.',

        s_goal: 'What is your primary fitness goal?',
        s_source: 'How did you find us?',
        s_role: 'What is your role in this group?',

        o_weight:   'Lose Weight',
        o_muscle:   'Build Muscle',
        o_cardio:   'Improve Cardio',
        o_mobility: 'Flexibility & Mobility',
        o_mental:   'Mental Health & Stress',
        o_health:   'Improve a Health Condition',
        o_yt: 'YouTube',
        o_search: 'Search Engine',
        o_friend: 'Friend/Family',
        o_tv: 'TV Ad',
        o_insta: 'Instagram',
        o_tiktok: 'TikTok',
        o_roku: 'Roku Store',
        o_fb: 'Facebook',
        o_other: 'Other',

        o_hr: 'HR / Benefits',
        o_lead: 'Team / Office Lead',
        o_owner: 'Gym / Studio Owner',
        o_coach: 'Coach / Trainer',
        o_house: 'Household Lead',
        o_friends: 'Friend Group Lead',
        o_exist: 'Current Member',
        o_online: 'Online Ad',
        o_link: 'LinkedIn',
        o_ref: 'Industry Peer',
        o_fair: 'Wellness Fair',
        
        s_level: 'What is your fitness level?',
          o_beginner: 'Beginner',
          o_intermediate: 'Intermediate',
          o_advanced: 'Advanced',
      },
      es: {
        alreadyMember: "¿Ya eres miembro?",
        logIn: "Iniciar sesión",
        upgradeWarning: "Nota: Ya tienes un plan Individual. Iniciar este plan Grupal creará una suscripción separada. Administra tu plan anterior en el portal después de la compra.",
        headline: 'Entrenamientos para todo tu equipo',
        subhead: 'Desbloquea el acceso ilimitado a todas las clases. Únete al movimiento global por una mejor salud.',
        forMyself: 'Para Mí',
        forMyGroup: 'Para Mi Grupo',
        startTrial: 'Comenzar Prueba',
        loggedInAs: 'Conectado como:',
        logOut: 'Cerrar sesión',
        whatsIncluded: 'Qué incluye',
        safeCheckout: 'Pago Garantizado y Seguro',
        monthly: 'Mensual',
        annual: 'Anual',
        year: 'año',
        month: 'mes',
        billed: 'Facturado',
        billedYearlyInd: 'Facturado Anualmente',
        billedYearlyGrp: 'Facturado Anualmente',
        billedMonthly: 'Facturado Mensualmente',
        members: 'miembros',
        seatMonthly: 'usuario mensual',
        equivalent: 'mes equivalente',
        hsaTitle: 'Pagar con tarjeta HSA/FSA',
        hsaDesc: 'Seleccione "TrueMed" al finalizar la compra para un cargo único.',
        checkoutNow: 'Pagar Ahora',
        contactSales: 'Contactar Ventas',
        enterpriseTitle: 'Empresas, Escuelas y Gimnasios',
        enterpriseDesc: 'Licencias por volumen, SSO/SAML y derechos de visualización especializados.',
        stepActivation: 'Activación',
        stepVerification: 'Verificación',
        stepAccess: 'Acceso',
        setupOrganization: 'Configurar Grupo',
        createOrganization: 'Crea tu grupo para continuar con la compra grupal.',
        organizationDetected: 'Tu grupo está listo.',
        continueCheckout: 'Continuar al pago',
        organizationRequired: 'Crea o únete a un grupo antes de continuar al pago.',
        welcomeBack: 'Bienvenido de nuevo',
        continueNext: 'Continuar al siguiente paso',
        notYou: '¿No eres tú? Cerrar sesión',
        createAccount: 'Crea tu cuenta para continuar.',
        groupCreated: 'Grupo Creado',
        groupReady: 'Tu grupo está listo. Puedes editar los detalles en tu panel después del pago.',
        continuePayment: 'Continuar al Pago',
        setupGroup: 'Configurar Grupo',
        setupGroupDesc: 'Crea el perfil de tu grupo. Puedes invitar a miembros más tarde.',
        individualMembership: 'Membresía Individual',
        groupAccess: 'Acceso Grupal',
        creatingFor: 'Creando membresía para:',
        redirecting: 'Redirigiendo...',
        secureSSL: 'Conexión SSL Segura',
        proceedCheckout: 'Proceder al Pago',
        personalizing: 'Personalizando Experiencia',
        skipSurvey: 'Omitir Encuesta',
        accessGranted: '¡Acceso Concedido!',
        syncing: 'Sincronizando tu cuenta. Redirigiendo a tu panel...',
        returnStep: 'Volver al paso anterior',
        cancel: 'Cancelar',
        savingAnnual: 'OBTÉN 5 MESES GRATIS',
        savingAnnualGroup: 'OBTÉN 2 MESES GRATIS',
        managingGroupMembership: 'Actualmente estás gestionando la membresía del grupo.',
        activeIndividualMembership: '¡Ya tienes una membresía individual activa! Gracias por ser parte de la comunidad.',
        manageMembership: 'Administrar membresía',
        activeBothMembership: 'Actualmente tienes membresías Individual y Grupal activas. Administra tu facturación para evitar cargos duplicados.',
        expiredAdminMessage: "Tu grupo <strong>{{groupName}}</strong> tiene una suscripción caducada. Puedes actualizar tu facturación para restaurar el acceso, o eliminar este grupo si deseas comenzar uno nuevo.",
        manageGroupBtn: "Gestionar Grupo",
        expiredMemberMessage: "Actualmente eres miembro del grupo <strong>{{groupName}}</strong>. Para comprar una nueva membresía de Grupo y comenzar tu propio grupo, primero debes salir de tu grupo actual.",
        manageAccountBtn: "Gestionar Cuenta",
        localCurrencyNote: 'Tu moneda local y los impuestos aplicables se calculan al finalizar la compra.',


        p_annual_name: 'Membresía Anual',
        p_monthly_name: 'Membresía Mensual',
        p_family_name: 'Plan Familiar',
        p_family_desc: 'Perfecto para hogares y equipos pequeños.',
        p_growth_name: 'Plan de Crecimiento',
        p_growth_desc: 'Ideal para equipos en expansión y grupos medianos.',
        p_business_name: 'Plan Empresarial',
        p_business_desc: 'Ideal para empresas en crecimiento. Invita empleados y sus familias.',

        f_i_1: 'Alcanza tus metas con +900 clases de HIIT, Fuerza, Yoga y Movilidad',
        f_i_2: 'Míralo en iOS, Escritorio, Roku y Chromecast',
        f_i_3: 'Pon tu propia música o mira TV mientras te ejercitas',
        f_i_4: 'Sigue programas de entrenamiento diarios para todos los niveles',
        f_i_5: 'Gestión de cuenta en línea; cancele en cualquier momento.',
        f_g_1: 'Todo lo incluido en planes individuales',
        f_g_2: 'Facturación y administración centralizada del grupo',
        f_g_3: 'Invitaciones y gestión de miembros sencilla',
        f_g_4: 'Soporte prioritario para grupos',
        f_g_5: 'Derechos de visualización y transmisión en gimnasios de oficina',
        f_g_6: 'Gestión de cuenta en línea; cancele en cualquier momento.',

        s_goal: '¿Cuál es tu objetivo principal?',
        s_source: '¿Cómo nos encontraste?',
        s_role: '¿Cuál es tu rol en este grupo?',

        o_weight:   'Perder Peso',
        o_muscle:   'Ganar Músculo',
        o_cardio:   'Mejorar el Cardio',
        o_mobility: 'Flexibilidad y Movilidad',
        o_mental:   'Salud Mental y Estrés',
        o_health:   'Mejorar una Condición de Salud',
        o_yt: 'YouTube',
        o_search: 'Buscador',
        o_friend: 'Amigo/Familia',
        o_tv: 'Anuncio TV',
        o_insta: 'Instagram',
        o_tiktok: 'TikTok',
        o_roku: 'Tienda Roku',
        o_fb: 'Facebook',
        o_other: 'Otro',

        o_hr: 'RRHH / Beneficios',
        o_lead: 'Líder de Equipo',
        o_owner: 'Dueño de Gimnasio',
        o_coach: 'Entrenador',
        o_house: 'Líder del Hogar',
        o_friends: 'Líder de Grupo',
        o_exist: 'Miembro Actual',
        o_online: 'Anuncio Online',
        o_link: 'LinkedIn',
        o_ref: 'Colega',
        o_fair: 'Feria de Salud',
        o_social: 'Redes Sociales',

        s_level: '¿Cuál es tu nivel de condición física?',
o_beginner: 'Principiante',
o_intermediate: 'Intermedio',
o_advanced: 'Avanzado',
      },
    };

    // ========================================================================
    // BASE DATA
    // ========================================================================
    const BASE_PLANS = {
      individual: [
        {
          id: 'annual',
          nameKey: 'p_annual_name',
          price: 89.99,
          formatted: '$89.99',
          symbol: '$',
          monthly: '7.50',
          savingsKey: 'savingAnnual',
          period: 'year',
        },
        {
          id: 'monthly',
          nameKey: 'p_monthly_name',
          price: 12.99,
          formatted: '$12.99',
          symbol: '$',
          monthly: null,
          savings: null,
          period: 'month',
        },
      ],
      group: [
        {
          id: 'group_family',
          nameKey: 'p_family_name',
          price: 59,
          formattedMonthly: '$59.00',
          priceAnnual: 590,
          formattedAnnual: '$590.00',
          savingsAnnualKey: 'savingAnnualGroup',
          seats: 10,
          period: 'month',
          perSeat: '5.90',
          perSeatAnnual: '4.92',
          descKey: 'p_family_desc',
        },
        {
          id: 'group_growth',
          nameKey: 'p_growth_name',
          price: 199,
          formattedMonthly: '$199.00',
          priceAnnual: 1990,
          formattedAnnual: '$1,990.00',
          savingsAnnualKey: 'savingAnnualGroup',
          seats: 50,
          period: 'month',
          perSeat: '3.98',
          perSeatAnnual: '3.32',
          descKey: 'p_growth_desc',
        },
        {
          id: 'group_business',
          nameKey: 'p_business_name',
          price: 399,
          formattedMonthly: '$399.00',
          priceAnnual: 3990,
          formattedAnnual: '$3,990.00',
          savingsAnnualKey: 'savingAnnualGroup',
          seats: 150,
          period: 'month',
          perSeat: '2.66',
          perSeatAnnual: '2.22',
          descKey: 'p_business_desc',
        },
      ],
    };

    const BASE_FEATURES = {
      individual: ['f_i_1', 'f_i_2', 'f_i_3', 'f_i_4','f_i_5'],
      group: ['f_g_1', 'f_g_2', 'f_g_3', 'f_g_4', 'f_g_5','f_g_6'],
    };

    const BASE_SURVEY = {
      individual: [
         {
          id: 'survey_fitness_level',
          labelKey: 's_level',
          options: [
            { val: 'beginner',     labelKey: 'o_beginner',     icon: 'emoji_people' },
            { val: 'intermediate', labelKey: 'o_intermediate', icon: 'directions_run' },
            { val: 'advanced',     labelKey: 'o_advanced',     icon: 'bolt' },
          ],
        },
        {
          id: 'survey_fitness_goal',
          labelKey: 's_goal',
          options: [
            { val: 'weight-loss',   labelKey: 'o_weight',   icon: 'monitor_weight' },
            { val: 'build-muscle',  labelKey: 'o_muscle',   icon: 'fitness_center' },
            { val: 'cardio',        labelKey: 'o_cardio',   icon: 'favorite' },
            { val: 'mobility',      labelKey: 'o_mobility', icon: 'self_improvement' },
            { val: 'mental-health', labelKey: 'o_mental',   icon: 'psychology' },
            { val: 'health-condition', labelKey: 'o_health', icon: 'health_and_safety' },
          ]
        },
        {
          id: 'survey_referral_source',
          labelKey: 's_source',
          options: [
            { val: 'youtube', labelKey: 'o_yt', icon: 'play_circle' },
            { val: 'google', labelKey: 'o_search', icon: 'search' },
            { val: 'friend', labelKey: 'o_friend', icon: 'group' },
            { val: 'tv_ad', labelKey: 'o_tv', icon: 'live_tv' },
            { val: 'instagram', labelKey: 'o_insta', icon: 'share' },
            { val: 'tiktok', labelKey: 'o_tiktok', icon: 'bolt' },
            { val: 'roku', labelKey: 'o_roku', icon: 'tv' },
            { val: 'facebook', labelKey: 'o_fb', icon: 'public' },
            { val: 'other', labelKey: 'o_other', icon: 'more_horiz' },
          ],
        },
      ],
      group: [
        {
          id: 'survey_group_role',
          labelKey: 's_role',
          options: [
            { val: 'hr', labelKey: 'o_hr', icon: 'badge' },
            { val: 'team-lead', labelKey: 'o_lead', icon: 'groups' },
            { val: 'owner', labelKey: 'o_owner', icon: 'storefront' },
            { val: 'coach', labelKey: 'o_coach', icon: 'sports' },
            { val: 'household', labelKey: 'o_house', icon: 'home' },
            { val: 'friends', labelKey: 'o_friends', icon: 'diversity_3' },
          ],
        },
        {
          id: 'survey_referral_source',
          labelKey: 's_source',
          options: [
            { val: 'existing', labelKey: 'o_exist', icon: 'person_add' },
            { val: 'search', labelKey: 'o_search', icon: 'manage_search' },
            { val: 'online_ad', labelKey: 'o_online', icon: 'ads_click' },
            { val: 'linkedin', labelKey: 'o_link', icon: 'work' },
            { val: 'referral', labelKey: 'o_ref', icon: 'handshake' },
            { val: 'youtube', labelKey: 'o_yt', icon: 'play_circle' },
            { val: 'fair', labelKey: 'o_fair', icon: 'event' },
            { val: 'social', labelKey: 'o_social', icon: 'public' },
            { val: 'other', labelKey: 'o_other', icon: 'more_horiz' },
          ],
        },
      ],
    };

    // ========================================================================
    // STATE MANAGEMENT
    // ========================================================================
    
    const state = {
      isModalOpen: false,
      isClerkLoaded: false,
      isCheckingMembership: true, 
      step: 1,
      view: 'individual',
      billingPeriod: 'annual',
      selectedPlan: 'annual',
      firstName: '',
      email: '',
      showPassword: false,
      surveyIndex: 0,
      surveyAnswers: {},
      isRedirecting: false,
      language: (window.GH_LOCALE === 'es') ? 'es' : 'en',
      rcGroupOffering: null,
      hasProEntitlement: false,
      membershipPlan: null,
      clerkOrgName: null,
      isGroupOwner: false
    };

    let authTransitionInProgress = false;

    function setState(newState) {
      Object.assign(state, newState);
      render();
    }

    function updateStateSilent(key, value) {
      state[key] = value;
    }
    

    // Add
    function sanitizeHtml(str) {
      if (!str) return '';
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
}

    // ========================================================================
    // TRANSLATION HELPERS
    // ========================================================================
    function t(key) {
      return TRANSLATIONS[state.language][key] || key;
    }

    function hasActiveOrganization() {
      return !!(window.Clerk && window.Clerk.organization);
    }

    function logOrganizationStatus(context) {
      const hasOrg = hasActiveOrganization();
      const org = window.Clerk && window.Clerk.organization ? window.Clerk.organization : null;
      const user = window.Clerk && window.Clerk.user ? window.Clerk.user : null;
      console.log('[Group HIIT] Clerk organization status', {
        context: context || 'unknown',
        isOrganizationalAccount: hasOrg,
        organizationId: org ? org.id : null,
        organizationName: org ? org.name : null,
        userId: user ? user.id : null,
        userEmail: user && user.primaryEmailAddress ? user.primaryEmailAddress.emailAddress : null,
      });
    }

    function getLocalizedPlans() {
      const plans = JSON.parse(JSON.stringify(BASE_PLANS[state.view]));
      return plans.map((p) => {
        p.name = t(p.nameKey);
        if (p.descKey) p.desc = t(p.descKey);
        if (p.savingsKey) p.savings = t(p.savingsKey);
        if (p.savingsAnnualKey) p.savingsAnnual = t(p.savingsAnnualKey);
        p.periodTranslated = p.period === 'year' ? t('year') : t('month');
        return p;
      });
    }

    function getLocalizedFeatures() {
      return BASE_FEATURES[state.view].map((key) => t(key));
    }

    function getLocalizedSurveys() {
      const surveys = JSON.parse(JSON.stringify(BASE_SURVEY[state.view]));
      return surveys.map((q) => {
        q.label = t(q.labelKey);
        q.options = q.options.map((opt) => {
          opt.label = t(opt.labelKey);
          return opt;
        });
        return q;
      });
    }

    // ========================================================================
    // MEMBERSHIP STATUS HELPERS
    // ========================================================================
    function getCurrentMembershipPlan() {
      const rawPlan =
        window.Clerk && window.Clerk.user && window.Clerk.user.publicMetadata
          ? String(window.Clerk.user.publicMetadata.plan_type || '').toLowerCase()
          : '';
      if (rawPlan === 'both' || rawPlan === 'group' || rawPlan === 'individual') return rawPlan;
      if (hasActiveOrganization()) return 'group';
      return null;
    }

    const getRCProductIdentifier = (planId, billingPeriod) => {
      if (planId === 'annual') return 'annual';
      if (planId === 'monthly') return 'monthly';

      const isAnnual = billingPeriod === 'annual';
      if (planId === 'group_family') return isAnnual ? '$rc_annual_3' : '$rc_monthly_1';
      if (planId === 'group_growth') return isAnnual ? '$rc_annual_2' : '$rc_monthly_2';
      if (planId === 'group_business') return isAnnual ? '$rc_annual_1' : '$rc_monthly_3';

      return planId;
    };

    async function syncClerkStateAfterOrganizationChange() {
  const freshOrgName = window.Clerk?.organization?.name || null;
  await refreshMembershipStatus();
  if (freshOrgName) {
    state.clerkOrgName = freshOrgName;
  }
  render();
}




    // ── REPLACEMENT: refreshMembershipStatus ──────────────────────────────────
    // Instead of running its own RC + Clerk checks, the checkout now delegates
    // to window.GH.checkAccess() and reads the resolved state.
    // This eliminates all duplicate RC initialization and org membership loops.

    async function refreshMembershipStatus() {
      if (!(window.Clerk && window.Clerk.user) || state.isLoggingOut) {
        if (!authTransitionInProgress) {
          setState({
            hasProEntitlement:  false,
            membershipPlan:     null,
            hasActiveIndividual: false,
            hasActiveGroup:     false,
            isGroupOwner:       false,
            isCheckingMembership: false
          });
        }
        return;
      }

      // Run the global GH check — this handles RC init, org lookup, and VIP override
      if (window.GH && typeof window.GH.checkAccess === 'function') {
        await window.GH.checkAccess();
      }

      // Read the resolved state from window.GH
      const type      = window.GH?.userType  ?? null;
      const hasAccess = window.GH?.hasAccess ?? false;

      // Map GH user types to the checkout's internal state flags
      const hasIndiv     = type === 'individual';
      const hasGroup     = ['group_owner', 'group_admin', 'group_member'].includes(type);
      const isGroupOwner = type === 'group_owner';

      // Resolve org name from GH or fall back to Clerk directly
  const orgName = window.GH?.orgName || 
  (window.Clerk?.organization?.name) || null;

      setState({
        hasProEntitlement:   hasAccess,
        hasActiveIndividual: hasIndiv,
        hasActiveGroup:      hasGroup,
        isGroupOwner:        isGroupOwner,
        clerkOrgName:        orgName,
        membershipPlan:      type,
        isCheckingMembership: false
      });
    }

    // ── ALSO REMOVE FROM CHECKOUT: the KNOWN_SUBSCRIPTION_IDS constant ───────
    // Find and delete this block from the top of your checkout file:
    //
    //   const KNOWN_SUBSCRIPTION_IDS = {
    //     individual: [ ... ],
    //     group: [ ... ]
    //   };
    //
    // It is no longer used since refreshMembershipStatus now delegates to GH.
    // The same data lives in GH_KNOWN_GROUP_SUB_IDS in clerk_global_scripts.

    // ========================================================================
    // COMPONENT RENDERERS
    // ========================================================================
    function StarRating(size = '14px') {
      const stars = [1, 2, 3, 4, 5]
        .map(
          (star) =>
            `<span class="material-symbols-outlined fill-current text-brand-dark drop-shadow-sm" style="font-size: ${size}; font-variation-settings: 'FILL' 1, 'wght' 400">star</span>`
        )
        .join('');
      return `<div class="flex gap-0.5">${stars}</div>`;
    }

    function StepIndicator() {
      const steps = [t('stepActivation'), t('stepVerification'), t('stepAccess')];
      let activeIndex = 0;
      if (state.step === 1 || state.step === 2) activeIndex = 0;
      if (state.step === 3) activeIndex = 1;
      if (state.step >= 4) activeIndex = 2;
      const progressWidth = (activeIndex / (steps.length - 1)) * 100;
      const stepsHtml = steps
        .map((label, i) => {
          const isActive = i <= activeIndex;
          const circleClass = isActive
            ? 'bg-brand-blue text-brand-dark shadow-lg shadow-cyan-500/30'
            : 'bg-white text-slate-400 border-2 border-slate-200';
          return `<div class="relative z-10 flex flex-col items-center"><div class="w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold transition-all duration-300 ${circleClass}">${
            i < activeIndex ? '<span class="material-symbols-outlined text-sm">check</span>' : i + 1
          }</div><span class="text-[10px] font-bold font-hess uppercase tracking-widest mt-3 ${
            isActive ? 'text-brand-dark' : 'text-slate-400'
          }">${label}</span></div>`;
        })
        .join('');
      return `<div class="max-w-md mx-auto mb-8 px-4 w-full"><div class="flex justify-between items-center relative w-full"><div class="absolute top-[15px] left-0 w-full h-0.5 bg-slate-200 z-0"></div><div class="absolute top-[15px] left-0 h-0.5 bg-brand-blue z-0 transition-all duration-700" style="width: ${progressWidth}%"></div>${stepsHtml}</div></div>`;
    }

    function LanguageSwitcher() {
      return `
        <div class="absolute top-4 right-4 z-20">
          <select onchange="Actions.setLanguage(this.value)" class="bg-white/80 backdrop-blur-sm border border-slate-200 rounded-lg text-xs font-bold uppercase tracking-widest text-slate-500 focus:outline-none focus:ring-2 focus:ring-brand-blue cursor-pointer py-2 px-3 shadow-sm hover:bg-white transition-colors">
            <option value="en" ${state.language === 'en' ? 'selected' : ''}> English</option>
            <option value="es" ${state.language === 'es' ? 'selected' : ''}> Español</option>
          </select>
        </div>`;
    }

    /* Using Google Tag Manager instead
     const initAmplitude = () => {
      !(function (e, t) {
        var n = e.amplitude || { _q: [], _iq: {} };
        if (n.invoked) e.console && console.error && console.error('Amplitude snippet has been loaded.');
        else {
          var r = function (e, t) {
              e.prototype[t] = function () {
                return this._q.push({ name: t, args: Array.prototype.slice.call(arguments, 0) }), this;
              };
            },
            s = function (e, t, n) {
              return function (r) {
                e._q.push({ name: t, args: Array.prototype.slice.call(arguments, 0), context: n });
              };
            },
            i = function (e) {
              return function () {
                return new r(e);
              };
            };
          var o =
            'init run track identify setProductId setQuantity setPrice logRevenue setRevenueType regenerateDeviceId group identify setUserId setUserProperties setOptOut setVersionName setDomain setDeviceId enableTracking setGlobalUserProperties identify group logEvent logRevenueV2 revenue logRevenueV2'.split(
              ' '
            );
          function a(e) {
            function t(t) {
              e[t] = s(e, t);
            }
            for (var n = 0; n < o.length; n++) t(o[n]);
          }
          a(n),
            (n.getInstance = function (e) {
              return (
                (e = (!e || 0 === e.length ? '$default_instance' : e).toLowerCase()),
                Object.prototype.hasOwnProperty.call(n._iq, e) || ((n._iq[e] = { _q: [] }), a(n._iq[e])),
                n._iq[e]
              );
            }),
            (e.amplitude = n);
        }
      })(window, document);

      if (window.amplitude && !AMPLITUDE_API_KEY.includes('INSERT_')) {
        window.amplitude.init(AMPLITUDE_API_KEY, null, {
          defaultTracking: { sessions: true, pageViews: true, formInteractions: false, fileDownloads: false },
        });
      }
    };
*/
   const trackEvent = (name, props = {}) => {
  try {
    // Safely grab the Clerk User ID if they are logged in (No PII/email)
    const userId = window.Clerk?.user?.id || null;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': name,
      'user_id': userId,
      'org_id': window.Clerk?.organization?.id || null,
      'plan_category': state.view,
      'plan_id': state.selectedPlan,
      'current_step': state.step,
      'value': props.value || 0,
      'currency': props.currency || 'USD', 
      ...props
    });
  } catch (e) { 
    console.warn('GTM tracking not ready:', e); 
  }

};
// ========================================================================
    // ERROR TRACKING & TRIPWIRES
    // ========================================================================
    
    // 1. Global JavaScript Error Catcher
    window.addEventListener('error', (event) => {
      trackEvent('System Error Caught', { 
        error_message: event.message, 
        error_file: event.filename,
        browser: navigator.userAgent
      });
    });

    // 2. The "Stuck Screen" Tripwire
    // Checks every 5 seconds to see if the user is trapped in a weird UI state
    // AFTER ✅
let _loaderStartTime = null;
let _loaderAlreadyFired = false;

setInterval(() => {
  if (!state.isModalOpen) {
    _loaderStartTime = null;
    _loaderAlreadyFired = false;
    return;
  }

  // Scenario A: User is logged in but stuck on Step 1 with an empty form
  const container = document.getElementById('clerk-signup-container');
  if (state.step === 1 && window.Clerk?.user && container && container.innerHTML === '') {
    trackEvent('UI Warning - Stuck on Step 1', { browser: navigator.userAgent });
  }

  // Scenario B: Loading spinner has been visible for too long (genuinely stuck)
  const isLoading = state.isCheckingMembership || state.isRedirecting;
  if (isLoading) {
    if (!_loaderStartTime) {
      _loaderStartTime = Date.now();
      _loaderAlreadyFired = false;
    } else if (!_loaderAlreadyFired && (Date.now() - _loaderStartTime) > 12000) {
      trackEvent('UI Warning - Infinite Loader', { 
        step: state.step, 
        checking_membership: state.isCheckingMembership,
        is_redirecting: state.isRedirecting
      });
      _loaderAlreadyFired = true;
    }
  } else {
    _loaderStartTime = null;
    _loaderAlreadyFired = false;
  }
}, 5000);
    // ========================================================================
    // REVENUECAT HELPERS
    // ========================================================================

    
  async function ensureRCInitialised(userId) {
  if (typeof Purchases === 'undefined' || typeof Purchases.Purchases === 'undefined') return false;
  
  try {
    const user = window.Clerk && window.Clerk.user ? window.Clerk.user : null;
    const organization = window.Clerk && window.Clerk.organization ? window.Clerk.organization : null;
    const safeId = userId || (user ? user.id : null);
    
    let instance = null;
    try { 
      instance = Purchases.Purchases.getSharedInstance(); 
    } catch (e) {
     
    }

    // 1. Configure or Log In
    if (!instance) {
      if (safeId) Purchases.Purchases.configure(REVENUECAT_PUBLIC_KEY, safeId);
      else Purchases.Purchases.configure(REVENUECAT_PUBLIC_KEY);
      instance = Purchases.Purchases.getSharedInstance();
    } else if (safeId) {
      const currentAppUserID = typeof instance.getAppUserID === 'function' ? instance.getAppUserID() : instance.appUserID;
      if (currentAppUserID !== safeId) {
  await instance.changeUser(safeId);
}
    }

    // 2. Sync Attributes (Email, Amplitude, and Org ID)
    if (user && typeof instance.setAttributes === 'function') {
      const attributes = {
        "$email": user.primaryEmailAddress?.emailAddress || user.emailAddresses?.[0]?.emailAddress,
        "$amplitudeUserId": safeId
      };

      //  Only add the clerk_org_id to the payload if an organization actually exists
      if (organization && organization.id) {
        attributes["clerk_org_id"] = organization.id;
      }

      // Try to grab Amplitude Device ID if the SDK is available on window
      try {
        if (window.amplitude && typeof window.amplitude.getDeviceId === 'function') {
          attributes["$amplitudeDeviceId"] = window.amplitude.getDeviceId();
        } else if (window.amplitude?.getInstance) {
          attributes["$amplitudeDeviceId"] = window.amplitude.getInstance().getDeviceId();
        }
      } catch (ampErr) {
        console.warn('[Group HIIT] Amplitude Device ID sync skipped');
      }

      await instance.setAttributes(attributes);
      console.log('[Group HIIT] RC Attributes Synced:', attributes);

      // First-touch attribution — only on new visitors
      if (!localStorage.getItem('gh_rc_anon_id')) {
        try {
          const params = new URLSearchParams(window.location.search);
          const attribution = {};
          if (document.referrer) attribution['first_referrer'] = document.referrer;
          if (params.get('utm_source'))   attribution['utm_source']   = params.get('utm_source');
          if (params.get('utm_medium'))   attribution['utm_medium']   = params.get('utm_medium');
          if (params.get('utm_campaign')) attribution['utm_campaign'] = params.get('utm_campaign');
          if (params.get('utm_keyword'))  attribution['utm_keyword']  = params.get('utm_keyword');
          if (params.get('utm_content'))  attribution['utm_content']  = params.get('utm_content');
          attribution['first_landing_page'] = window.location.pathname;
          if (Object.keys(attribution).length > 0) {
            await instance.setAttributes(attribution);
          }
        } catch(e) {}
      }
          }

          return true;
        } catch (e) {
          console.warn('[Group HIIT] RC Init/Sync suppressed:', e.message);
          return false;
        }
}
// ── CURRENCY DETECTION ─────────────────────────────────────────────────────
const RC_CURRENCY_MAP = {
  // North America
  CA: 'CAD', MX: 'MXN',
  // Europe
  GB: 'GBP', DE: 'EUR', FR: 'EUR', IT: 'EUR', ES: 'EUR',
  NL: 'EUR', BE: 'EUR', AT: 'EUR', PT: 'EUR', IE: 'EUR',
  FI: 'EUR', GR: 'EUR', SK: 'EUR', SI: 'EUR', EE: 'EUR',
  LV: 'EUR', LT: 'EUR', LU: 'EUR', MT: 'EUR', CY: 'EUR',
  CH: 'CHF', SE: 'SEK', NO: 'NOK', DK: 'DKK', PL: 'PLN',
  CZ: 'CZK', HU: 'HUF', RO: 'RON', HR: 'HRK', BG: 'BGN',
  // Asia Pacific
  AU: 'AUD', NZ: 'NZD', JP: 'JPY', SG: 'SGD', HK: 'HKD',
  KR: 'KRW', IN: 'INR', TH: 'THB', MY: 'MYR', PH: 'PHP',
  ID: 'IDR', TW: 'TWD', VN: 'VND',
  // Middle East & Africa
  AE: 'AED', SA: 'SAR', ZA: 'ZAR', IL: 'ILS', NG: 'NGN',
  // Latin America
  BR: 'BRL', AR: 'ARS', CO: 'COP', CL: 'CLP', PE: 'PEN',
};

const detectedCurrency = window.GH_DETECTED_CURRENCY || undefined;
    async function fetchGroupOffering() {
      if (state.rcGroupOffering) return state.rcGroupOffering;
      const ok = await ensureRCInitialised();
      if (!ok) return null;
      try {
        const offeringsOptions = detectedCurrency ? { currency: detectedCurrency } : {};
        const allOfferings = (await Purchases.Purchases.getSharedInstance().getOfferings(offeringsOptions)).all;
        const offering = allOfferings[RC_GROUP_OFFERING_ID] || null;
        state.rcGroupOffering = offering;
        return offering;
      } catch (e) {
        console.error('Could not fetch group offering', e);
        return null;
      }
    }

    async function updatePricesFromRevenueCat() {
  if (typeof Purchases === 'undefined' || typeof Purchases.Purchases === 'undefined') return;
  try {
    let rcInstance = null;
    try { rcInstance = Purchases.Purchases.getSharedInstance(); } catch(e) {}
    if (!rcInstance) {
      console.warn('[GH] RC not initialized yet, skipping price fetch');
      return;
    }
    const offeringsOptions = detectedCurrency ? { currency: detectedCurrency } : {};
    const allOfferings = (await rcInstance.getOfferings(offeringsOptions)).all;

        const indOffering = allOfferings[RC_INDIVIDUAL_OFFERING_ID];
        if (indOffering) {
          BASE_PLANS.individual.forEach((plan) => {
            const pkgId = RC_PACKAGE_MAP.individual[plan.id];
            const pkg = indOffering.availablePackages.find((p) => p.identifier === pkgId);
            if (pkg) {
            plan.formatted = pkg.webBillingProduct.currentPrice.formattedPrice;
            plan.price = pkg.webBillingProduct.currentPrice.amount / 100;
            plan.currencyCode = pkg.webBillingProduct.currentPrice.currencyCode; // ADD THIS
              const sym = plan.formatted.match(/^[^\d]+/);
              if (sym) plan.symbol = sym[0].trim();
              if (plan.id === 'annual') {
                const mo = (plan.price / 12).toFixed(2);
                plan.monthly = mo;
              }
            }
          });
        }

        const grpOffering = allOfferings[RC_GROUP_OFFERING_ID];
        if (grpOffering) {
          state.rcGroupOffering = grpOffering;
          BASE_PLANS.group.forEach((plan) => {
            const monthlyPkg = grpOffering.availablePackages.find(
              (p) => p.identifier === RC_PACKAGE_MAP.group[`${plan.id}_monthly`]
            );
            const annualPkg = grpOffering.availablePackages.find(
              (p) => p.identifier === RC_PACKAGE_MAP.group[`${plan.id}_annual`]
            );
            if (monthlyPkg) {
              const p = monthlyPkg.webBillingProduct;
              plan.formattedMonthly = p.currentPrice.formattedPrice;
              plan.price = p.currentPrice.amount / 100;
                plan.currencyCode = p.currentPrice.currencyCode; 
              plan.perSeat = (plan.price / plan.seats).toFixed(2);
            }
            if (annualPkg) {
              const p = annualPkg.webBillingProduct;
              plan.formattedAnnual = p.currentPrice.formattedPrice;
              plan.priceAnnual = p.currentPrice.amount / 100;
              plan.perSeatAnnual = (plan.priceAnnual / 12 / plan.seats).toFixed(2);
            }
          });
        }

        render();
      } catch (e) {
        console.log('Could not fetch localised prices', e);
      }
    }

    // ========================================================================
    // CLERK INTEGRATION HELPERS
    // ========================================================================
    async function saveToClerkMetadata() {
      if (window.Clerk && window.Clerk.user) {
        const user = window.Clerk.user;
        try {
          const currentUnsafe = user.unsafeMetadata || {};
          const currentPublic = user.publicMetadata || {};
          const existingPlan = String(currentUnsafe.plan_type || currentPublic.plan_type || '').toLowerCase();
          
          let newPlanType = state.view;
          if ((existingPlan === 'individual' && state.view === 'group') || 
              (existingPlan === 'group' && state.view === 'individual') || 
              existingPlan === 'both') { newPlanType = 'both';
          }

          //  THE FIX: Restored state.surveyAnswers to ensure they actually save!
          await user.update({
            unsafeMetadata: { 
              ...currentUnsafe, 
              ...state.surveyAnswers,
              onboarding_completed: true, 
              plan_type: newPlanType, 
              preferred_language: state.language,
              registration_source: 'web', 
            }
          });
        } catch (err) { console.error('[Group HIIT] Error updating Clerk metadata:', err);
        }
      }
    }

    function mountClerkComponent() {
      const container = document.getElementById('clerk-signup-container');
      // FIX: Only draw form if clerk is loaded and user is strictly NOT logged in. Ends ghost flashing.
      if (container && container.innerHTML === '' && window.Clerk && state.isClerkLoaded && !window.Clerk.user) {
        const redirectUrl = new URL(window.location.href);
        // FIX 2: Point to the target step so Clerk doesn't reset the form
        const nextStep = (state.view === 'group' && !hasActiveOrganization()) ? '2' : '3';
        redirectUrl.searchParams.set('step', nextStep); 
        redirectUrl.searchParams.set('planType', state.view);
       redirectUrl.searchParams.set('plan', state.selectedPlan);
// Only set period for group plans — individual plans don't use it
if (state.view === 'group') {
  redirectUrl.searchParams.set('period', state.billingPeriod);
} else {
  redirectUrl.searchParams.delete('period');
}
        
        window.Clerk.mountSignUp(container, {
          initialValues: { firstName: '', lastName: '', emailAddress: '' }, // FIX: Stop pre-fill
          routing: 'virtual', // FIX: No hard reload on signup
          appearance: {
            variables: { colorPrimary: '#00bcd4', fontFamily: 'Poppins, sans-serif', borderRadius: '1rem', fontSize: '0.875rem' },
            elements: {
              rootBox: 'w-full flex justify-center',
              cardBox: '!shadow-none !border-none !bg-transparent w-full !max-w-full mx-auto',
              card: '!shadow-none !border-none !bg-transparent w-full !max-w-full mx-auto !p-0',
              headerTitle: 'hidden',
              headerSubtitle: 'hidden',
              socialButtonsBlockButton: 'h-12 w-full border-2 border-slate-200 rounded-2xl text-slate-600 hover:bg-slate-50 hover:border-slate-300 transition-all',
              socialButtonsBlockButtonText: 'font-poppins font-bold text-xs uppercase tracking-wider',
              socialButtonsProviderIcon: 'w-5 h-5',
              dividerLine: 'bg-slate-200 h-[2px]',
              dividerText: 'text-slate-300 font-black text-[10px] uppercase tracking-widest bg-white px-2',
              formFieldRow: 'mb-3',
              formFieldLabel: 'font-poppins font-bold text-[10px] uppercase tracking-widest text-slate-400 mb-1.5 ml-1',
              formFieldInput: 'h-16 w-full border-2 border-slate-100 bg-slate-50 focus:border-brand-blue focus:bg-white rounded-2xl text-brand-dark font-bold text-sm px-4 py-5 transition-all outline-none shadow-sm box-border',
              formFieldSuccessMessage: 'text-brand-green font-bold text-xs mt-1 ml-1',
              formFieldErrorText: 'text-red-500 font-bold text-xs mt-1 ml-1',
              formButtonPrimary: 'h-14 w-full bg-brand-dark hover:bg-slate-800 text-brand-gold text-sm font-black uppercase tracking-widest rounded-2xl shadow-lg hover:shadow-xl transition-all transform active:scale-[0.98] mt-4',
              footer: 'hidden',
              footerActionText: 'hidden',
              footerActionLink: 'hidden',
            },
          },
          fallbackRedirectUrl: redirectUrl.toString(),
          signInFallbackRedirectUrl: redirectUrl.toString(),
        });
      }
    }

    function mountClerkOrgComponent() {
      const container = document.getElementById('clerk-org-container');
      if (!container || !window.Clerk || !state.isClerkLoaded) return;

      // 1. If they already have an org, don't show the form, just jump to Step 3
      if (hasActiveOrganization()) {
        Actions.setStep(3);
        return;
      }

      if (container.innerHTML !== '') return;
      // 2. Safety check for Clerk Org features
      if (typeof window.Clerk.mountCreateOrganization !== 'function') {
        container.innerHTML = `<div class="rounded-[24px] border border-red-100 bg-red-50 px-5 py-4 text-left"><p class="text-sm font-semibold text-red-700 m-0 p-0">${t('organizationRequired')}</p></div>`;
        return;
      }

      // 3. Mount the Clerk Organization Creator
      window.Clerk.mountCreateOrganization(container, {
        routing: 'virtual', 
        appearance: {
          variables: { colorPrimary: '#00bcd4', fontFamily: 'Poppins, sans-serif', borderRadius: '1rem', fontSize: '0.875rem' },
          elements: {
            organizationAvatarUploader: 'hidden',          // FIX: Hide Logo Upload
            organizationAvatarUploaderContainer: 'hidden', // FIX: Hide Logo Upload
            rootBox: 'w-full flex justify-center',
            cardBox: '!shadow-none !border-none !bg-transparent w-full !max-w-full mx-auto',
            card: '!shadow-none !border-none !bg-transparent w-full !max-w-full mx-auto !p-0',
            headerTitle: 'hidden',
            headerSubtitle: 'hidden',
            formFieldRow: 'mb-3',
            formFieldLabel: 'font-poppins font-bold text-[10px] uppercase tracking-widest text-slate-400 mb-1.5 ml-1',
            formFieldInput: 'h-12 w-full border-2 border-slate-100 bg-slate-50 focus:border-brand-blue focus:bg-white rounded-2xl text-brand-dark font-bold text-sm p-4 transition-all outline-none shadow-sm box-border',
            formFieldErrorText: 'text-red-500 font-bold text-xs mt-1 ml-1',
            formButtonPrimary: 'h-14 w-full bg-brand-dark hover:bg-slate-800 text-brand-gold text-sm font-black uppercase tracking-widest rounded-2xl shadow-lg hover:shadow-xl transition-all transform active:scale-[0.98] mt-4',
            footer: 'hidden',
          },
        },
        afterCreateOrganizationUrl: window.location.href,
        skipInvitationScreen: false,
      });

      // 4. THE SUCCESS POLLER: This fixes the "Blank Box" ugh-moment.
      // It watches for the exact moment the org is created and forces the jump to Step 3.
      const checkOrganizationInterval = setInterval(async () => {
        if (hasActiveOrganization()) {
          clearInterval(checkOrganizationInterval);
          
          // Instantly hide the creator to prevent flicker
          if (container) container.style.display = 'none';

          // FORCE the jump to Step 3 (Access/Survey)
          Actions.setStep(3);
          
          trackEvent('Organization Created', { 
            organization_id: window.Clerk.organization ? window.Clerk.organization.id : null 
          });
          
          // Final background sync
          await syncClerkStateAfterOrganizationChange();
        }
      }, 250);
    }

    // ========================================================================
    // CHECKOUT HANDLERS
    // ========================================================================

   

   const handleIndividualCheckout = async () => {
     sessionStorage.removeItem('gh_checkout_intent'); // ✅ Clear intent on purchase
      const rcInstance = Purchases.Purchases.getSharedInstance();
      const allOfferings = (await rcInstance.getOfferings()).all;
      const offering = allOfferings[RC_INDIVIDUAL_OFFERING_ID];
      const pkgId = RC_PACKAGE_MAP.individual[state.selectedPlan];
      const pkg = offering.availablePackages.find((p) => p.identifier === pkgId);
      
      if (!pkg) throw new Error('No matching individual package found');
      
      const user = window.Clerk?.user;
      const userEmail = user?.primaryEmailAddress?.emailAddress;
      const userId = user?.id;

      if (!userEmail || !userId) {
        return alert('Session sync in progress. Please click the button again in 2 seconds.');
      }

      await rcInstance.purchase({
        rcPackage: pkg,
        ...(pkg.webBillingProduct?.defaultSubscriptionOption && { purchaseOption: pkg.webBillingProduct.defaultSubscriptionOption }),
        selectedLocale: state.language === 'es' ? 'es' : navigator.language, // (or state.language === 'es' ...)
        customerEmail: userEmail,
        skipSuccessPage: true,
      });
      
      // MOVE TO SURVEY INSTANTLY
      updateStateSilent('isRedirecting', false);
      updateStateSilent('step', 4);
      updateStateSilent('surveyIndex', 0);
      render();

      trackEvent('Checkout Completed', { method: 'RevenueCat', plan_id: state.selectedPlan, revenue_type: 'individual' });
      await saveToClerkMetadata();
    };

    const handleGroupCheckout = async () => {
       sessionStorage.removeItem('gh_checkout_intent'); // ✅ Clear intent on purchase
      const rcInstance = Purchases.Purchases.getSharedInstance();
      const key = `${state.selectedPlan}_${state.billingPeriod}`;
      const pkgId = RC_PACKAGE_MAP.group[key];
      
      const offerings = await rcInstance.getOfferings();
      const currentOffering = offerings.all[RC_GROUP_OFFERING_ID];
      if (!currentOffering) throw new Error('Group offering not available');
      
      const pkg = currentOffering.availablePackages.find((p) => p.identifier === pkgId);
      if (!pkg) throw new Error(`Package ${pkgId} not found in group offering`);

      const user = window.Clerk?.user;
      const userEmail = user?.primaryEmailAddress?.emailAddress;
      const userId = user?.id;
      const activeOrgId = window.Clerk?.organization?.id || user?.organizationMemberships?.[0]?.organization?.id;

      if (!userEmail || !userId) {
        return alert('Session sync in progress. Please click the button again in 2 seconds.');
      }

      if (activeOrgId) {
        try {
          if (typeof rcInstance.setAttributes === 'function') {
            await rcInstance.setAttributes({ "clerk_org_id": activeOrgId });
          }
        } catch (attrError) {}
      }

      await rcInstance.purchase({
        rcPackage: pkg,
        ...(pkg.webBillingProduct?.defaultSubscriptionOption && { purchaseOption: pkg.webBillingProduct.defaultSubscriptionOption }),
        selectedLocale: state.language === 'es' ? 'es' : navigator.language, // (or state.language === 'es' ...)
        customerEmail: userEmail,
        skipSuccessPage: true,
      });

      updateStateSilent('isRedirecting', false);
      updateStateSilent('step', 4);
      updateStateSilent('surveyIndex', 0);
      render();

      trackEvent('Checkout Completed', { method: 'RevenueCat', plan_id: state.selectedPlan, revenue_type: 'group' });
      await saveToClerkMetadata();
    };
    
    // ========================================================================
    // ACTIONS
    // ========================================================================
const Actions = {
   syncClerkStateAfterOrganizationChange: async () => {
    await syncClerkStateAfterOrganizationChange();
  },
      handleLogout: async () => {
        
        if (window.Clerk) {
          state.isLoggingOut = true;

          if (typeof Purchases !== 'undefined' && Purchases.Purchases) {
             try { await Purchases.Purchases.getSharedInstance().logOut(); } catch(e){}
          }

          // THE FIX: Strip the modal triggers out of the URL completely
          const returnUrl = new URL(window.location.href);
          returnUrl.searchParams.set('step', '1');          // ← keep modal open at Step 1
          returnUrl.searchParams.set('planType', state.view);
          returnUrl.searchParams.set('plan', state.selectedPlan);
          if (state.view === 'group') {
            returnUrl.searchParams.set('period', state.billingPeriod);
          } else {
            returnUrl.searchParams.delete('period');
          }

          await window.Clerk.signOut();

          // Wipe Amplitude tracking for the old user
          try {
            if (window.amplitude && typeof window.amplitude.getInstance === 'function') {
              window.amplitude.getInstance().setUserId(null);
              window.amplitude.getInstance().regenerateDeviceId();
            }
          } catch(e) {}

          window.location.replace(returnUrl.toString()); // Reloads without the modal
        }
      },
      openNativeSignIn: (fromModal = false) => {
        let redirectUrl = window.location.href;
        
        if (fromModal) {
          const currentUrl = new URL(window.location.href);
          currentUrl.searchParams.set('step', '1'); 
          currentUrl.searchParams.set('planType', state.view); 
          currentUrl.searchParams.set('plan', state.selectedPlan); 
          
          // THE URL FIX: Only show 'period' if it's a group plan
          if (state.view === 'group') {
            currentUrl.searchParams.set('period', state.billingPeriod);
          } else {
            currentUrl.searchParams.delete('period');
          }
          
          window.history.replaceState(null, '', currentUrl.toString());
          redirectUrl = currentUrl.toString();
        } else {
          const cleanUrl = new URL(window.location.href);
          cleanUrl.searchParams.delete('step');
          cleanUrl.searchParams.delete('planType');
          cleanUrl.searchParams.delete('plan');
          cleanUrl.searchParams.delete('period');
          redirectUrl = cleanUrl.toString();
        }
        
        window.Clerk.openSignIn({ fallbackRedirectUrl: redirectUrl });
      },

      setView: (newView) => {
        const plan = newView === 'individual' ? 'annual' : 'group_family';
        setState({ view: newView, selectedPlan: plan });
        //  SAVE TO MEMORY
        sessionStorage.setItem('gh_checkout_intent', JSON.stringify({ view: newView, plan: plan, period: state.billingPeriod }));
        trackEvent('View Changed', { new_view: newView });
      },
      setLanguage: (lang) => {
        setState({ language: lang });
        trackEvent('Language Changed', { language: lang });
      },
      setSelectedPlan: (planId) => {
        setState({ selectedPlan: planId });
        // SAVE TO MEMORY
        sessionStorage.setItem('gh_checkout_intent', JSON.stringify({ view: state.view, plan: planId, period: state.billingPeriod }));
        trackEvent('Plan Selected', { plan_id: planId });
      },
      toggleBillingPeriod: () => {
        const newPeriod = state.billingPeriod === 'monthly' ? 'annual' : 'monthly';
        setState({ billingPeriod: newPeriod });
        //  SAVE TO MEMORY
        sessionStorage.setItem('gh_checkout_intent', JSON.stringify({ view: state.view, plan: state.selectedPlan, period: newPeriod }));
      },
      openModal: () => {
        //  THE SAFETY CHECK: Match the sidebar logic exactly
        const hasClerkOrgAccess = window.Clerk?.user?.organizationMemberships?.some(
          m => m.organization?.publicMetadata?.ghprogramall === true || m.organization?.publicMetadata?.ghprogramall === 'true'
        );
        const isUpgrading = state.view === 'group' && state.hasActiveIndividual && !state.hasActiveGroup;

        if ((state.hasProEntitlement || state.hasActiveIndividual || (state.hasActiveGroup && state.hasProEntitlement) || hasClerkOrgAccess) && !isUpgrading) {
          console.log("Checkout blocked: Active membership detected.");
          // Instead of opening a broken modal, we just send them to the portal
          Actions.openManageMembership();
          return; 
        }

        // ---  ---
        window.scrollTo({ top: window.scrollY * 0.3, behavior: 'smooth' });
        let startingStep = 1;

        if (window.Clerk && window.Clerk.user) {
          startingStep = (state.view === 'group' && !hasActiveOrganization()) ? 2 : 3;
        }

        try {
          const url = new URL(window.location.href);
          url.searchParams.set('step', startingStep);
          url.searchParams.set('planType', state.view); 
          url.searchParams.set('plan', state.selectedPlan); 
          
          // THE URL FIX: Only show 'period' if it's a group plan
          if (state.view === 'group') {
            url.searchParams.set('period', state.billingPeriod); 
          } else {
            url.searchParams.delete('period'); 
          }
          
          window.history.replaceState(null, '', url.toString());
        } catch (e) {}

        setState({ isModalOpen: true, step: startingStep });
        trackEvent('Checkout Started', { initial_view: state.view });
      },
      skipActivation: () => setState({ step: state.view === 'group' ? 2 : 3 }),

      closeModal: () => {
        if (state.step === 4) {
          window.location.href = SUCCESS_REDIRECT_URL;
        } else if (state.step < 5) {
          try { window.history.replaceState(null, '', window.location.pathname);
          } catch (e) {}
          setState({ isModalOpen: false, isRedirecting: false });
        }
      },

      setStep: (newStep) => {
        // GATEKEEPER: If we are already on this step, do nothing.
        // This stops the infinite flashing loop.
        if (state.step === newStep) return;

        setState({ step: newStep });
        try {
          const url = new URL(window.location.href);
          url.searchParams.set('step', newStep);
          window.history.replaceState(null, '', url.toString());
        } catch (e) {}
      },

      backStep: () => {
        let newStep = state.step - 1;
        if (state.step === 2) newStep = 1;
        if (state.step === 3 && state.view === 'individual') newStep = 1;
        setState({ step: newStep, isRedirecting: false });
        
        try {
          const url = new URL(window.location.href);
          url.searchParams.set('step', newStep);
          window.history.replaceState(null, '', url.toString());
        } catch (e) {}
      },

      handleShopifyHSA: () => (window.location.href = `https://${SHOPIFY_STORE_URL}/cart/${SHOPIFY_HSA_VARIANT_ID}:1`),
      
      openManageMembership: () => {
        // 1. Buyers (Individual or Group Owner) -> Go to Shopify Billing Portal
        if (state.hasActiveIndividual || state.isGroupOwner) {
          window.location.href = `https://${SHOPIFY_STORE_URL}/pages/manage-membership`;
          return;
        }

        // Check if they are an admin in Clerk (but not the payer)
        const memberships = window.Clerk?.user?.organizationMemberships || [];
        const isClerkAdmin = memberships.some(m => m.role === 'org:admin');

        // 2. Delegated Admin -> Manage team members via Clerk
        if (isClerkAdmin) {
          // Note: If they don't have an active workspace set, Clerk might require them 
          // to select it first, but this correctly triggers the Org management modal.
          if (window.Clerk.organization) {
            window.Clerk.openOrganizationProfile({ afterLeaveOrganizationUrl: window.location.href });
          } else {
            window.Clerk.openUserProfile({ section: 'organizations' });
          }
        } 
        // 3. Standard Member -> Manage their own personal profile
        else {
          window.Clerk.openUserProfile({ section: 'organizations' });
        }
      },

      handleStandardCheckout: async () => {
        trackEvent('Checkout Clicked');
        if (state.view === 'group' && !hasActiveOrganization()) {
          setState({ step: 2, isRedirecting: false });
          alert(t('organizationRequired'));
          return;
        }

        const isReady = await ensureRCInitialised();
        if (!isReady) return alert('RevenueCat SDK not loaded.');

        state.isRedirecting = true;
        const btn = document.getElementById('checkout-btn');
        const statusBox = document.getElementById('status-container');
        if (btn) {
          btn.disabled = true;
          btn.innerHTML = '...';
          btn.classList.add('opacity-50', 'cursor-not-allowed');
        }
        if (statusBox) {
          statusBox.innerHTML = `<div class="flex justify-center mb-3"><dotlottie-player src="https://cdn.shopify.com/s/files/1/1021/9561/files/Loading_GH.json?v=1775340924" background="transparent" speed="1" style="width: 50px; height: 50px;"
          loop autoplay></dotlottie-player></div><p class="text-[10px] font-bold text-slate-400 uppercase tracking-widest leading-relaxed px-4 text-center m-0 p-0 animate-pulse">${t('redirecting')}</p>`;
        }

        //  THE BACKGROUND SYNC: Silently fetch the absolute latest user data 
        // from Clerk's database before opening the Stripe checkout.
        try {
          if (window.Clerk && window.Clerk.user) {
            await window.Clerk.user.reload();
          }
        } catch (syncError) {
          console.warn('[Group HIIT] Background sync delayed, proceeding with local data.', syncError);
        }

        try {
          if (state.view === 'individual') {
            await handleIndividualCheckout();
          } else {
            await handleGroupCheckout();
          }
        } catch (e) {
          console.log("Checkout halted. Returning to Step 3:", e);
          setState({ isRedirecting: false });
        }
      },

      finishCheckout: () => (window.location.href = SUCCESS_REDIRECT_URL),
      
      handleSurveyOption: (selectedValue) => {
        const currentQuestions = getLocalizedSurveys();
        const currentQuestion = currentQuestions[state.surveyIndex];
        const updatedAnswers = { ...state.surveyAnswers, [currentQuestion.id]: selectedValue };

        if (state.surveyIndex < currentQuestions.length - 1) {
          setState({ surveyIndex: state.surveyIndex + 1, surveyAnswers: updatedAnswers });
        // AFTER ✅
        } else {
          setState({ step: 5, surveyAnswers: updatedAnswers });
          saveToClerkMetadata();
          trackEvent('Survey Completed', updatedAnswers);
          const finalPlan = getSelectedPlanData();
          trackEvent('Purchase Success', { 
            value: finalPlan?.price || 0, 
            currency: finalPlan?.currencyCode || 'USD' 
          });

          // NEW: Fire survey data to RevenueCat Custom Attributes
          try {
            if (typeof Purchases !== 'undefined' && typeof Purchases.Purchases !== 'undefined') {
              const rcInstance = Purchases.Purchases.getSharedInstance();
              if (typeof rcInstance.setAttributes === 'function') {
                // RevenueCat accepts a flat object of strings, which perfectly matches our updatedAnswers
                rcInstance.setAttributes(updatedAnswers);
              }
            }
          } catch (rcError) {
            console.warn('[Group HIIT] Failed to sync survey to RevenueCat:', rcError);
          }
          // END NEW

          try {
            if (window.amplitude && typeof window.amplitude.getInstance === 'function') {
              window.amplitude.getInstance().setUserProperties(updatedAnswers);
            }
          } catch (e) {}
          
          setTimeout(() => { window.location.href = SUCCESS_REDIRECT_URL; }, 3500);
        }
      },
      
      // AFTER 
    
        skipSurvey: () => {
  const finalPlan = getSelectedPlanData();
  trackEvent('Purchase Success', { 
    value: finalPlan?.price || 0, 
    currency: finalPlan?.currencyCode || 'USD' 
  });
  setState({ step: 5 });
        saveToClerkMetadata();
        setTimeout(() => { window.location.href = SUCCESS_REDIRECT_URL; }, 3500);
      }
    };

    // ========================================================================
    // VIEW RENDERERS
    // ========================================================================
    const getSelectedPlanData = () => {
      const localizedPlans = getLocalizedPlans();
      return localizedPlans.find((p) => p.id === state.selectedPlan) || localizedPlans[0];
    };

    function getCheckoutBlockState() {
      let isCheckoutBlocked = false; 
      let blockedMessage = '';

      if (state.hasActiveIndividual && state.hasActiveGroup) {
        blockedMessage = t('activeBothMembership');
        isCheckoutBlocked = true;
      } 
      else if (state.view === 'individual') {
        if (state.hasActiveIndividual) {
          blockedMessage = t('activeIndividualMembership');
          isCheckoutBlocked = true;
        } else if (state.hasActiveGroup && state.hasProEntitlement) {
  const groupName = state.clerkOrgName ? `(${sanitizeHtml(state.clerkOrgName)})` : '';
  blockedMessage = state.isGroupOwner
    ? `You currently have full access through your Group Membership ${groupName}. Since you manage the billing, you must cancel your group subscription in the portal before switching to an individual plan.`
    : `You currently have full access through your Group Membership ${groupName}. To switch to an individual plan, you must first leave your current group.`;
  isCheckoutBlocked = true;
}
      } 
      else if (state.view === 'group') {
  if (state.hasActiveGroup && state.hasProEntitlement) {
    const groupName = state.clerkOrgName ? `(${sanitizeHtml(state.clerkOrgName)})` : '';
    blockedMessage = state.isGroupOwner 
      ? `You are currently managing the group membership ${groupName}. To upgrade or downgrade your group size, please use the portal.` 
      : `Your access is provided by your group ${groupName}.`;
    isCheckoutBlocked = true;
  }
}
      return { isCheckoutBlocked, blockedMessage };
    }

    const renderMainContentHtml = () => {
      if (state.isCheckingMembership && state.step < 4) {
        return `${LanguageSwitcher()}<div class="max-w-6xl mx-auto px-4 md:px-6 py-12 w-full pt-16"><div class="text-center mb-10"><h1 class="text-4xl md:text-5xl font-black font-hess text-brand-dark tracking-tight mb-4 uppercase italic leading-none text-balance text-center m-0 p-0">${t('headline')}</h1><p class="text-slate-500 font-medium text-lg max-w-2xl mx-auto leading-relaxed text-balance text-center italic px-4 text-center mt-2 m-0 p-0">${t('subhead')}</p></div><div class="flex justify-center items-center py-20"><div class="flex justify-center items-center">
  <dotlottie-player src="https://cdn.shopify.com/s/files/1/1021/9561/files/Loading_GH.json?v=1775340924" background="transparent" speed="1" style="width: 120px; height: 120px;"
  loop autoplay></dotlottie-player>
</div></div></div>`;
      }

      const localizedPlans = getLocalizedPlans();
      const localizedFeatures = getLocalizedFeatures();
      const currentUserEmail = window.Clerk?.user?.primaryEmailAddress?.emailAddress || null;
      
      // Standard compact login message
      const loginHtml = currentUserEmail 
        ? `<p class="text-[10px] font-medium text-slate-400 text-center mb-6 mt-2">${t('loggedInAs')} <strong class="text-slate-600">${currentUserEmail}</strong> • <button onclick="Actions.handleLogout()" class="underline cursor-pointer hover:text-brand-dark">${t('logOut')}</button></p>`
        : `<p class="text-[12px] font-medium text-slate-500 text-center mb-6 mt-4 italic">${t('alreadyMember')} <button onclick="Actions.openNativeSignIn(false)" class="text-brand-blue font-bold hover:text-cyan-600 cursor-pointer underline ml-1">${t('logIn')}</button></p>`;
      
      // LOG OUT REMOVED VERSION: For active subscribers to prevent redirect issues
      const loginHtmlNoLogout = currentUserEmail 
        ? `<p class="text-[10px] font-medium text-slate-400 text-center mb-6 mt-2">${t('loggedInAs')} <strong class="text-slate-600">${currentUserEmail}</strong></p>`
        : loginHtml;

      const { isCheckoutBlocked, blockedMessage } = getCheckoutBlockState();

      const renderPricingCards = () => {
        return localizedPlans.map((plan) => {
          const isSelected = state.selectedPlan === plan.id;
          const isGroup = state.view === 'group';
          const containerClass = `p-6 md:p-8 rounded-[32px] border-4 cursor-pointer transition-all relative flex flex-col md:flex-row justify-between items-start md:items-center gap-4 min-w-0 ${isSelected ? (isGroup ? 'border-brand-gold bg-brand-dark shadow-2xl scale-[1.01]' : 'border-brand-blue bg-white shadow-2xl scale-[1.01]') : 'border-transparent bg-white shadow-sm hover:shadow-md opacity-90 hover:opacity-100'}`;
          const circleClass = isSelected ? (isGroup ? 'border-brand-gold bg-brand-gold' : 'border-brand-blue bg-brand-blue') : 'border-slate-300';
          const titleColor = isGroup && isSelected ? 'text-white' : 'text-brand-dark';
          const priceColor = isGroup && isSelected ? 'text-white' : 'text-brand-dark';
          
          let displayPrice = isGroup 
            ? (state.billingPeriod === 'annual' ? (plan.formattedAnnual || '$' + plan.priceAnnual) : (plan.formattedMonthly || '$' + plan.price)) 
            : (plan.formatted || '$' + plan.price);
          
          const currency = plan.currencyCode || detectedCurrency || 'USD';

        let periodLabel = isGroup 
        ? (state.billingPeriod === 'annual' ? `${plan.seats} ${t('members')} • ${t('billedYearlyGrp')} • ${currency}` : `${plan.seats} ${t('members')} • ${t('billedMonthly')} • ${currency}`) 
        : (plan.period === 'year' ? `${t('billedYearlyInd')} • ${currency}` : `${t('billedMonthly')} • ${currency}`);
          
          let savingsBadge = (isGroup && state.billingPeriod === 'annual' && plan.savingsAnnualKey) 
            ? `<div class="absolute -top-3 right-8 bg-brand-green text-white px-4 py-1 rounded-full text-[10px] font-bold font-hess uppercase tracking-widest shadow-lg z-20">${t(plan.savingsAnnualKey)}</div>` 
            : (!isGroup && plan.savingsKey ? `<div class="absolute -top-3 right-8 bg-brand-green text-white px-4 py-1 rounded-full text-[10px] font-bold font-hess uppercase tracking-widest shadow-lg z-20">${t(plan.savingsKey)}</div>` : '');

          let perSeatText = '';
          if (isGroup) {
              const perSeatValue = state.billingPeriod === 'annual' ? plan.perSeatAnnual : plan.perSeat;
              if (perSeatValue) {
                 const shadowStyle = isSelected ? '' : 'text-shadow: 0.5px 0.5px 0px rgba(0,0,0,0.15);';
                 perSeatText = `<p class="font-bold text-[10px] uppercase tracking-widest mt-1 italic leading-none m-0 p-0" style="color: #FBC02D; ${shadowStyle}">AS LOW AS $${perSeatValue}/SEAT MONTHLY</p>`;
              }
          }

          const descContent = plan.desc ? `
            <div class="min-h-[38px] flex flex-col justify-center mt-1">
              <p class="${isGroup && isSelected ? 'text-slate-300' : 'text-slate-500'} text-xs font-medium italic leading-tight m-0 p-0">${plan.desc}</p>
              ${perSeatText}
            </div>` : '';

          return `
            <div onclick="Actions.setSelectedPlan('${plan.id}')" class="${containerClass}">
              ${savingsBadge}
              <div class="flex items-center gap-5 flex-grow">
                <div class="w-6 h-6 rounded-full border-2 flex-shrink-0 flex items-center justify-center ${circleClass}">
                  ${isSelected ? '<div class="w-2 h-2 bg-white rounded-full"></div>' : ''}
                </div>
                <div class="flex-grow min-w-0">
                  <h3 class="text-xl font-bold font-hess ${titleColor} leading-tight m-0 p-0">${plan.name}</h3>
                  ${descContent}
                </div>
              </div>
              <div id="groupprice" class="text-right flex-shrink-0">
                <p class="text-3xl font-black font-hess ${priceColor} leading-none m-0 p-0">${displayPrice}</p>
                <p class="text-[10px] font-bold text-slate-400 uppercase tracking-widest mt-1 font-hess m-0 p-0">${periodLabel}</p>
              </div>
            </div>`;
        }).join('');
      };
      
      const featuresHtml = localizedFeatures.map(feature => `<li class="flex items-start gap-3 text-sm font-medium text-slate-700 leading-snug"><span class="material-symbols-outlined text-brand-green text-[20px] flex-shrink-0">verified</span>${feature}</li>`).join('');
      const sidebarBtnAction = isCheckoutBlocked ? "Actions.openManageMembership()" : "Actions.openModal()";
      const sidebarBtnText = isCheckoutBlocked ? t('manageMembership') : t('startTrial');
      const sidebarBtnColor = isCheckoutBlocked ? "bg-brand-dark text-brand-gold shadow-slate-900/20" : (state.view === 'individual' ? "bg-brand-blue text-brand-dark shadow-cyan-500/20" : "bg-brand-dark text-brand-gold shadow-slate-900/20");
      const currencyNoteHtml = `<p class="text-slate-400 font-medium text-xs text-center mt-4 m-0 p-0">${t('localCurrencyNote')}</p>`;
      const hsaHtml = state.view === 'individual' ? currencyNoteHtml + `<div onclick="Actions.handleShopifyHSA()" class="mt-6 p-6 rounded-[24px] border-2 border-slate-300 bg-slate-50 flex items-center justify-between group cursor-pointer hover:border-slate-400 transition-all opacity-90 hover:opacity-100"><div class="flex items-center gap-4"><div class="w-10 h-10 bg-white rounded-xl flex items-center justify-center text-slate-300 border border-slate-200 shadow-sm"><span class="material-symbols-outlined text-xl text-brand-blue">medical_services</span></div><div><h4 class="font-bold text-sm text-slate-700 font-poppins m-0 p-0">${t('hsaTitle')}</h4><p class="text-xs text-brand-blue font-bold uppercase tracking-wide m-0 p-0 mt-1">${t('hsaDesc')}</p></div></div><div class="text-right"><p class="text-sm font-black font-hess text-brand-dark m-0 p-0">${localizedPlans[0].formatted || '$89.99'}</p>
      <span class="text-[9px] font-bold uppercase text-brand-blue tracking-widest group-hover:underline">${t('checkoutNow')} </span></div></div>` : currencyNoteHtml;      
      const groupContactHtml = state.view === 'group' ? `<div class="p-5 bg-white/40 rounded-[24px] border border-slate-200 flex flex-col md:flex-row justify-between items-center gap-4 mt-6"><div class="text-left pl-0"><h4 class="text-[13px] font-black font-poppins text-brand-dark uppercase tracking-tight m-0 p-0">${t('enterpriseTitle')}</h4><p class="text-[11px] text-slate-500 font-medium m-0 p-0">${t('enterpriseDesc')}</p></div><button class="text-[10px] font-black text-brand-blue uppercase underline underline-offset-4 decoration-2 hover:text-cyan-700 transition-colors whitespace-nowrap font-hess">${t('contactSales')}</button></div>` : '';
      const billingToggleHtml = state.view === 'group' ? `<div class="flex items-center justify-center gap-4 mb-6 animate-in slide-in-from-bottom-4 fade-in py-1"><span class="text-xs font-bold font-hess uppercase tracking-widest transition-colors ${state.billingPeriod === 'monthly' ? 'text-brand-dark' : 'text-slate-400'}">${t('monthly')}</span><div onclick="Actions.toggleBillingPeriod()" class="w-14 h-8 rounded-full p-1 cursor-pointer transition-colors duration-300 ${state.billingPeriod === 'annual' ? 'bg-brand-gold' : 'bg-slate-200'} relative"><div class="w-6 h-6 bg-white rounded-full shadow-md transform transition-transform duration-300 ${state.billingPeriod === 'annual' ? 'translate-x-6' : 'translate-x-0'}"></div></div><span class="text-xs font-bold font-hess uppercase tracking-widest transition-colors ${state.billingPeriod === 'annual' ? 'text-brand-dark' : 'text-slate-400'}">${t('annual')}</span></div>` : '';

      return `${LanguageSwitcher()}<div class="max-w-6xl mx-auto px-4 md:px-6 py-12 animate-in slide-in-from-bottom-4 duration-700 w-full pt-16"><div class="text-center mb-10"><h1 class="text-4xl md:text-5xl font-black font-hess text-brand-dark tracking-tight mb-4 uppercase italic leading-none text-balance text-center m-0 p-0">${t('headline')}</h1><p class="text-slate-500 font-medium text-lg max-w-2xl mx-auto leading-relaxed text-balance text-center italic px-4 text-center mt-2 m-0 p-0">${t('subhead')}</p></div><div class="flex p-1 bg-slate-200/50 rounded-2xl w-fit mx-auto mb-10 border border-slate-200"><button onclick="Actions.setView('individual')" class="px-8 py-3 rounded-xl font-bold font-hess text-xs uppercase tracking-widest transition-all ${state.view === 'individual' ? 'bg-white shadow-md text-brand-blue' : 'text-slate-500'}">${t('forMyself')}</button><button onclick="Actions.setView('group')" class="px-8 py-3 rounded-xl font-bold font-hess text-xs uppercase tracking-widest transition-all ${state.view === 'group' ? 'bg-slate-900 shadow-md text-brand-gold' : 'text-slate-500'}">${t('forMyGroup')}</button></div><div class="grid lg:grid-cols-12 gap-8 items-start w-full">
        <div class="lg:col-span-7 space-y-4 w-full" id="priceoptions">
          <div class="space-y-4">${billingToggleHtml}${renderPricingCards()}${hsaHtml}${groupContactHtml}</div>
          <div class="lg:hidden pt-4 pb-8"><button onclick="${isCheckoutBlocked ? 'Actions.openManageMembership()' : 'Actions.openModal()'}" class="w-full py-5 rounded-2xl font-bold font-hess text-lg uppercase tracking-widest shadow-xl transition-all active:scale-95 mb-4 ${isCheckoutBlocked ? 'bg-brand-dark text-brand-gold' : 'bg-brand-blue text-brand-dark'}">${isCheckoutBlocked ? t('manageMembership') : t('startTrial')}</button>${isCheckoutBlocked ? loginHtmlNoLogout : loginHtml}</div>
        </div>
        <div class="lg:col-span-5 w-full">
          <div class="bg-white p-8 md:p-10 rounded-[40px] shadow-xl border border-slate-100 lg:sticky lg:top-8 relative">
            ${isCheckoutBlocked ? `<div class="mb-8"><h4 class="text-[10px] font-bold font-hess text-slate-400 uppercase tracking-[0.2em] mb-4 m-0 p-0">Membership Active</h4><p class="text-sm text-slate-500 leading-relaxed italic m-0 p-0">${blockedMessage}</p></div>` : `<div class="absolute -top-4 -right-4 bg-brand-gold text-brand-dark font-hess font-bold text-xs uppercase px-4 py-2 rounded-full shadow-lg transform rotate-3 z-20 border-2 border-white">14-Day Free Trial</div><h4 class="text-[10px] font-bold font-hess text-slate-400 uppercase tracking-[0.2em] mb-6 m-0 p-0">${t('whatsIncluded')}</h4><ul class="space-y-4 mb-10">${featuresHtml}</ul>`}
            <button onclick="${sidebarBtnAction}" class="hidden lg:block w-full py-5 rounded-2xl font-bold font-hess text-lg uppercase tracking-widest shadow-xl transition-all active:scale-95 mb-2 ${sidebarBtnColor}">${sidebarBtnText}</button>
            <div class="hidden lg:block">${isCheckoutBlocked ? loginHtmlNoLogout : loginHtml}</div>
            ${!isCheckoutBlocked ? `<div class="bg-slate-50 rounded-2xl p-5 border border-slate-200 text-center mt-4"><div class="flex flex-col items-center gap-1.5"><div class="flex items-center gap-2">${StarRating()}<span class="text-[10px] font-black font-hess text-brand-dark uppercase tracking-widest">${REVIEWS_COUNT}</span></div><p class="text-[9px] font-bold text-slate-500 uppercase tracking-[0.1em] italic leading-tight px-4 text-center m-0 p-0">${SOCIAL_PROOF_TEXT}</p></div></div><div class="mt-6 border-t border-slate-100 pt-6 text-center"><p class="text-[9px] font-bold text-slate-300 uppercase tracking-widest italic mb-3">${t('safeCheckout')}</p><div class="flex justify-center items-center gap-3 flex-wrap max-w-[320px] mx-auto py-2"><img src="https://cdn.shopify.com/s/files/1/1021/9561/files/stripe.png?v=1774980392" class="h-4 w-auto object-contain" alt="Stripe" /><img src="https://cdn.shopify.com/s/files/1/1021/9561/files/link.png?v=1789238278" class="h-6 w-auto object-contain" alt="Link" /><div class="h-4 w-px bg-slate-200 mx-1"></div><img src="https://cdn.shopify.com/s/files/1/1021/9561/files/visa.png?v=1774980392" class="h-3 w-auto object-contain" alt="Visa" /><img src="https://cdn.shopify.com/s/files/1/1021/9561/files/mastercard.png?v=1774980392" class="h-5 w-auto object-contain" alt="Mastercard" /><img src="https://cdn.shopify.com/s/files/1/1021/9561/files/amex.png?v=1774980392" class="h-5 w-auto object-contain" alt="Amex" /><img src="https://cdn.shopify.com/s/files/1/1021/9561/files/discover.png?v=1774980392" class="h-3 w-auto object-contain" alt="Discover" /><img src="https://cdn.shopify.com/s/files/1/1021/9561/files/diners.png?v=1774980392" class="h-4 w-auto object-contain" alt="Diners Club" /><img src="https://cdn.shopify.com/s/files/1/1021/9561/files/jcb.png?v=1774980392" class="h-4 w-auto object-contain" alt="JCB" /><img src="https://cdn.shopify.com/s/files/1/1021/9561/files/unionpay.png?v=1774980392" class="h-4 w-auto object-contain" alt="UnionPay" /><img src="https://cdn.shopify.com/s/files/1/1021/9561/files/applepay.png?v=1774980392" class="h-4 w-auto object-contain" alt="Apple Pay" /><img src="https://cdn.shopify.com/s/files/1/1021/9561/files/gpay.png?v=1774980392" class="h-4 w-auto object-contain" alt="Google Pay" /></div></div>` : ''}
          </div>
        </div>
      </div></div>`;
    };

   const renderStickyFooterHtml = () => {
      if (state.isModalOpen || state.isCheckingMembership) return '';
      
      const { isCheckoutBlocked } = getCheckoutBlockState();
      const planData = getSelectedPlanData();
      let priceString = state.view === 'group' ? (state.billingPeriod === 'annual' ? (planData.formattedAnnual || '$' + planData.priceAnnual) : (planData.formattedMonthly || '$' + planData.price)) : (planData.formatted || '$' + planData.price);
      
      const btnAction = isCheckoutBlocked ? "Actions.openManageMembership()" : "Actions.openModal()";
      const btnText = isCheckoutBlocked ? t('manageMembership') : t('startTrial');
      
      // ⚡️ Define colors manually since we are outside the Tailwind wall
      const bgColor = isCheckoutBlocked ? "#1e293b" : (state.view === 'individual' ? "#00bcd4" : "#1e293b"); 
      const textColor = isCheckoutBlocked ? "#fbbf24" : (state.view === 'individual' ? "#1e293b" : "#fbbf24"); 

      const displayLabel = isCheckoutBlocked ? btnText : `${btnText} • ${priceString}`;

      // ⚡️ THE FIX: Bulletproof inline HTML & CSS to completely bypass Tailwind!
      return `
        <div style="position: fixed; bottom: 0; left: 0; width: 100%; padding: 16px; padding-bottom: calc(16px + env(safe-area-inset-bottom)); background-color: rgba(255, 255, 255, 0.95); -webkit-backdrop-filter: blur(12px); backdrop-filter: blur(12px); border-top: 1px solid #f1f5f9; z-index: 2147483647; box-sizing: border-box;">
          <button onclick="${btnAction}" style="width: 100%; padding: 18px 16px; background-color: ${bgColor}; color: ${textColor}; border-radius: 12px; font-weight: 800; font-family: inherit; font-size: 14px; text-transform: uppercase; letter-spacing: 0.1em; border: none; box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.15); cursor: pointer; display: block; box-sizing: border-box;">
            ${displayLabel}
          </button>
        </div>
        <style>
          /* Make sure this detached mobile portal stays hidden on large desktop screens */
          @media (min-width: 1024px) {
            #gh-sticky-portal { display: none !important; }
          }
        </style>
      `;
    };
    
    const renderModalHtml = () => {
      if (!state.isModalOpen) return '';

      //  UNIVERSAL GATEKEEPER
      const hasClerkOrgAccess = window.Clerk?.user?.organizationMemberships?.some(
        m => m.organization?.publicMetadata?.ghprogramall === true || m.organization?.publicMetadata?.ghprogramall === 'true'
      );
      
      // FIX: Add exceptions so the gatekeeper doesn't break upgrades or post-purchase surveys
      const isUpgrading = state.view === 'group' && state.hasActiveIndividual && !state.hasActiveGroup;
      const isPostPurchase = state.step === 4 || state.step === 5; 

      if ((state.hasProEntitlement || state.hasActiveIndividual || (state.hasActiveGroup && state.hasProEntitlement) || hasClerkOrgAccess) && !isUpgrading && !isPostPurchase) {
        if (!state.isLoggingOut) {
            setTimeout(() => {
              Actions.closeModal();
              // Scroll them to the sidebar so they see their status
              const sidebar = document.querySelector('.lg\\:sticky');
              if (sidebar) sidebar.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }, 100);
            return '';
        }
      }

      const renderModalContent = () => {
        if (state.isCheckingMembership) {
          return `<div class="text-center py-16"><div class="flex justify-center items-center mb-6"><dotlottie-player src="https://cdn.shopify.com/s/files/1/1021/9561/files/Loading_GH.json?v=1775340924" background="transparent" speed="1" style="width: 80px; height: 80px;" loop autoplay></dotlottie-player></div><p class="text-[10px] font-bold text-slate-400 uppercase tracking-widest animate-pulse m-0 p-0">${t('syncing')}</p></div>`;
        }

        switch (state.step) {
          case 1: 
            const hasClerkOrgAccess1 = window.Clerk?.user?.organizationMemberships?.some(
              m => m.organization?.publicMetadata?.ghprogramall === true || m.organization?.publicMetadata?.ghprogramall === 'true'
            );
            if ((state.hasProEntitlement || state.hasActiveIndividual || (state.hasActiveGroup && state.hasProEntitlement) || hasClerkOrgAccess1) && !isUpgrading && !isPostPurchase) {
              let activeMessage = '';
              if (state.hasActiveIndividual && (state.hasActiveGroup || hasClerkOrgAccess1)) {
                activeMessage = t('activeBothMembership');
              } else if (state.hasActiveIndividual) {
                activeMessage = t('activeIndividualMembership');
              } else {
                const groupName = state.clerkOrgName ? `(${sanitizeHtml(state.clerkOrgName)})` : 'your group';
                activeMessage = state.isGroupOwner
                  ? `You are currently managing the group membership ${groupName}. To upgrade or downgrade your group size, please use the portal.`
                  : `Your access is provided by your group ${groupName}. If you want to switch to an individual plan, you must first leave your current group.`;
              }
              
              return `
                <div class="text-center py-6 px-4">
                  <div class="w-16 h-16 bg-green-50 rounded-full flex items-center justify-center mx-auto mb-4 text-green-500">
                    <span class="material-symbols-outlined text-4xl">verified_user</span>
                  </div>
                  <h3 class="text-xl font-bold text-slate-800 mb-6 leading-tight">${activeMessage}</h3>
                  <button onclick="Actions.openManageMembership()" class="w-full bg-brand-dark text-brand-gold font-bold py-4 rounded-xl hover:brightness-110 transition-all shadow-lg uppercase tracking-widest font-hess text-sm">
                    ${t('manageMembership')}
                  </button>
                </div>`;
            }

            if (window.Clerk && window.Clerk.user) {
              const userEmail = window.Clerk.user.primaryEmailAddress?.emailAddress || 'User';
              return `<div class="text-center relative py-6"><div class="w-16 h-16 bg-brand-blue/10 rounded-full flex items-center justify-center mx-auto mb-4 text-brand-blue"><span class="material-symbols-outlined text-3xl">account_circle</span></div><h2 class="text-3xl font-black font-hess tracking-tight text-brand-dark mb-2 uppercase italic leading-none text-center m-0 p-0">${t('welcomeBack')}</h2><p class="text-sm text-slate-500 font-medium mb-8 leading-relaxed italic text-balance px-4 text-center m-0 p-0 mt-2">${t('loggedInAs')} <strong>${userEmail}</strong></p><button onclick="Actions.skipActivation()" class="w-full py-4 rounded-xl font-bold font-hess text-brand-dark bg-brand-blue shadow-lg uppercase tracking-widest hover:brightness-110 transition-all mb-4">${t('continueNext')}</button><button onclick="Actions.handleLogout()" class="text-[10px] font-bold text-slate-400 uppercase tracking-widest hover:text-brand-dark transition-colors">${t('notYou')}</button></div>`;
            } else {
              return `<div class="text-center relative"><h2 class="text-3xl font-black font-hess tracking-tight text-brand-dark mb-2 uppercase italic leading-none text-center m-0 p-0">${t('stepActivation')}</h2><p class="text-sm text-slate-500 font-medium mb-6 leading-relaxed italic text-balance px-4 text-center m-0 p-0 mt-2">${t('createAccount')}</p><div id="clerk-signup-container" class="min-h-[350px] mb-8"></div><div class="mt-4 pb-6"><p class="text-xs font-medium text-slate-500">${t('alreadyMember')} <button onclick="Actions.openNativeSignIn(true)" class="text-brand-blue font-bold hover:text-cyan-600 underline cursor-pointer ml-1">${t('logIn')}</button></p></div></div>`;
            }

        case 2:{
          const hasClerkOrgAccessStep2 = window.Clerk?.user?.organizationMemberships?.some(
            m => m.organization?.publicMetadata?.ghprogramall === true || m.organization?.publicMetadata?.ghprogramall === 'true'
          );
          if ((state.hasProEntitlement || state.hasActiveIndividual || (state.hasActiveGroup && state.hasProEntitlement) || hasClerkOrgAccessStep2) && !isUpgrading && !isPostPurchase) {
            Actions.setStep(1);
            return '';
          }

          const organizationReady = hasActiveOrganization();
          const orgReadyText = state.clerkOrgName 
          ? (state.language === 'es' 
            ? `Tu grupo, <strong>${sanitizeHtml(state.clerkOrgName)}</strong>, está listo. Puedes editarlo después del pago.` 
            : `Your group, <strong>${sanitizeHtml(state.clerkOrgName)}</strong>, is ready. You can edit it after you check out.`)
          : (state.language === 'es' 
            ? 'Tu grupo está listo. Puedes editarlo después del pago.' 
            : 'Your group is ready. You can edit it after you check out.');
          
          
          const userMemberships = window.Clerk?.user?.organizationMemberships || [];
const adminOrgs = userMemberships.filter(m => 
  m.role === 'org:admin' || m.membership?.role === 'org:admin'
);

const orgSwitcherHtml = adminOrgs.length > 1
  ? `<div class="mt-6 pt-5 border-t border-slate-100">
      <p class="text-[11px] text-slate-500 font-medium mb-3 text-center">Buying for a different group?</p>
      <div class="space-y-2">
        ${adminOrgs.map(m => {
          const org = m.organization;
          const isActive = window.Clerk?.organization?.id === org.id;
          return `<button 
            onclick="window.Clerk.setActive({ organization: '${org.id}' }).then(() => { updateStateSilent('clerkOrgName', '${sanitizeHtml(org.name)}'); render(); setTimeout(() => Actions.syncClerkStateAfterOrganizationChange(), 300); })"
            class="w-full flex items-center gap-3 p-3 rounded-xl border-2 transition-all text-left ${isActive ? 'border-brand-blue bg-brand-blue/5' : 'border-slate-200 bg-slate-50 hover:border-slate-300'}"
          >
            ${org.imageUrl 
              ? `<img src="${org.imageUrl}" class="w-8 h-8 rounded-lg object-cover flex-shrink-0" />` 
              : `<div class="w-8 h-8 rounded-lg bg-brand-blue/10 flex items-center justify-center flex-shrink-0 text-brand-blue font-bold text-xs">${sanitizeHtml(org.name?.charAt(0) || '?')}</div>`
            }
            <span class="font-semibold text-sm text-brand-dark flex-1">${sanitizeHtml(org.name)}</span>
            ${isActive ? '<span class="text-[10px] font-bold text-brand-blue uppercase tracking-widest">Active</span>' : ''}
          </button>`;
        }).join('')}
      </div>
    </div>`
  : '';

return `<div class="text-center relative"><h2 class="text-3xl font-black font-hess tracking-tight text-brand-dark mb-2 uppercase italic leading-none text-center m-0 p-0">${t('setupOrganization')}</h2><p class="text-sm text-slate-500 font-medium mb-6 leading-relaxed italic text-balance px-4 text-center m-0 p-0 mt-2">${organizationReady ? orgReadyText : t('createOrganization')}</p>${organizationReady ? `<button onclick="Actions.setStep(3)" class="w-full py-4 rounded-xl font-bold font-hess text-brand-dark bg-brand-blue shadow-lg uppercase tracking-widest hover:brightness-110 transition-all mb-4">${t('continueCheckout')}</button>${orgSwitcherHtml}` : '<div id="clerk-org-container" class="min-h-[320px] mb-8"></div>'}</div>`;
        }
        case 3: {
          const hasClerkOrgAccessStep3 = window.Clerk?.user?.organizationMemberships?.some(
            m => m.organization?.publicMetadata?.ghprogramall === true || m.organization?.publicMetadata?.ghprogramall === 'true'
          );
          if ((state.hasProEntitlement || state.hasActiveIndividual || (state.hasActiveGroup && state.hasProEntitlement) || hasClerkOrgAccessStep3) && !isUpgrading && !isPostPurchase) {
            Actions.setStep(1);
            return '';
          }

          const plan = getSelectedPlanData();
          const accessLabel = state.view === 'individual' ? t('individualMembership') : t('groupAccess');
          const currentUserEmailCheck = window.Clerk?.user?.primaryEmailAddress?.emailAddress || null;
          const groupNameHtml = (state.view === 'group' && state.clerkOrgName) ? `<br><span class="text-slate-400">Group:</span> <strong class="text-brand-dark">${state.clerkOrgName}</strong>` : '';
          const loggedInText = currentUserEmailCheck ? `<p class="text-[10px] text-slate-500 font-medium mb-3">${t('creatingFor')} <strong class="text-brand-dark">${currentUserEmailCheck}</strong>${groupNameHtml}</p>` : '';
          let displayPriceModal = state.view === 'group' ? (state.billingPeriod === 'annual' ? plan.formattedAnnual || '$' + plan.priceAnnual : plan.formattedMonthly || '$' + plan.price) : (plan.formatted || '$' + plan.price);
          let billingLabel = state.view === 'group' ? (state.billingPeriod === 'annual' ? '/' + t('year') : '/' + t('month')) : (plan.period === 'year' ? '/' + t('year') : '/' + t('month'));
          const buttonStyles = state.view === 'group' ? 'bg-brand-dark text-brand-gold hover:bg-slate-800 shadow-xl shadow-slate-900/20' : 'bg-brand-blue text-brand-dark hover:bg-cyan-600 shadow-xl shadow-cyan-500/20';
          
          return `<div><div class="bg-white rounded-[32px] overflow-hidden border border-slate-100 shadow-inner">
          <div class="bg-brand-dark p-8 text-white">
  <div class="flex justify-between items-center mb-1">
    <p class="text-[10px] font-bold uppercase tracking-widest text-brand-blue m-0 p-0">${t('stepVerification')}</p>
    <p class="text-[10px] font-bold uppercase text-slate-400 m-0 p-0">${accessLabel}</p>
  </div>
 <div class="flex justify-between items-end gap-3">
  <h3 class="text-xl font-bold font-hess uppercase tracking-tight leading-tight m-0 p-0 min-w-0">${plan.name}</h3>
  <p class="text-xl font-black font-hess text-white tracking-tighter m-0 p-0 flex-shrink-0">${displayPriceModal}<span class="text-sm font-medium font-poppins text-white/80 ml-1">${billingLabel}</span></p>

</div>
  ${state.view === 'group' ? `<p class="text-[10px] text-brand-gold/70 font-bold uppercase tracking-widest mt-2 m-0 p-0">${plan.seats} ${t('members')}</p>` : ''}
</div>
<div class="p-8 text-center relative">
  ${state.view === 'group' && state.hasActiveIndividual ? `<div class="bg-amber-50 border border-amber-200 rounded-2xl p-5 mb-6 text-left shadow-sm"><p class="text-[11px] text-amber-800 font-medium m-0 p-0">${t('upgradeWarning')}</p></div>` : ''}<div id="status-container" class="min-h-[80px] bg-slate-50 rounded-[24px] border-2 border-dashed border-slate-200 flex flex-col items-center justify-center p-6 mb-6 text-balance">
            ${state.isRedirecting 
              ? `<div class="flex justify-center mb-3"><dotlottie-player src="https://cdn.shopify.com/s/files/1/1021/9561/files/Loading_GH.json?v=1775340924" background="transparent" speed="1" style="width: 50px; height: 50px;" loop autoplay></dotlottie-player></div><p class="text-[10px] font-bold text-slate-400 uppercase tracking-widest leading-relaxed px-4 text-center m-0 p-0 animate-pulse">${t('redirecting')}</p>` 
              : `<span class="material-symbols-outlined text-brand-green text-lg">lock_person</span><p class="text-[10px] font-bold text-slate-400 uppercase tracking-widest m-0 p-0">${t('secureSSL')}</p>`}
          </div>
          <div class="mb-6"><div class="flex justify-center items-center gap-3 flex-wrap max-w-[320px] mx-auto py-2"><img src="https://cdn.shopify.com/s/files/1/1021/9561/files/stripe.png?v=1774980392" class="h-4 w-auto object-contain" alt="Stripe" /><img src="https://cdn.shopify.com/s/files/1/1021/9561/files/link.png?v=1789238278" class="h-6 w-auto object-contain" alt="Link" /><div class="h-4 w-px bg-slate-200 mx-1"></div><img src="https://cdn.shopify.com/s/files/1/1021/9561/files/visa.png?v=1774980392" class="h-3 w-auto object-contain" alt="Visa" /><img src="https://cdn.shopify.com/s/files/1/1021/9561/files/mastercard.png?v=1774980392" class="h-5 w-auto object-contain" alt="Mastercard" /><img src="https://cdn.shopify.com/s/files/1/1021/9561/files/amex.png?v=1774980392" class="h-5 w-auto object-contain" alt="Amex" /><img src="https://cdn.shopify.com/s/files/1/1021/9561/files/discover.png?v=1774980392" class="h-3 w-auto object-contain" alt="Discover" /><img src="https://cdn.shopify.com/s/files/1/1021/9561/files/diners.png?v=1774980392" class="h-4 w-auto object-contain" alt="Diners Club" /><img src="https://cdn.shopify.com/s/files/1/1021/9561/files/jcb.png?v=1774980392" class="h-4 w-auto object-contain" alt="JCB" /><img src="https://cdn.shopify.com/s/files/1/1021/9561/files/unionpay.png?v=1774980392" class="h-4 w-auto object-contain" alt="UnionPay" /><img src="https://cdn.shopify.com/s/files/1/1021/9561/files/applepay.png?v=1774980392" class="h-4 w-auto object-contain" alt="Apple Pay" /><img src="https://cdn.shopify.com/s/files/1/1021/9561/files/gpay.png?v=1774980392" class="h-4 w-auto object-contain" alt="Google Pay" /></div></div>${loggedInText}<button id="checkout-btn" onclick="Actions.handleStandardCheckout()" class="w-full py-5 mb-6 rounded-2xl font-bold font-hess text-sm uppercase tracking-widest transition-all ${buttonStyles} ${state.isRedirecting ? 'opacity-50 cursor-not-allowed' : ''}" ${state.isRedirecting ? 'disabled' : ''}>${state.isRedirecting ? '...' : t('proceedCheckout')}</button></div></div></div>`;
          }
          case 4: 
            const questions = getLocalizedSurveys();
            const q = questions[state.surveyIndex];
            const gridCols = q.options.length > 4 ? 'grid-cols-2 md:grid-cols-3' : 'grid-cols-2';
            const optionsHtml = q.options.map((opt) => `<button onclick="Actions.handleSurveyOption('${opt.val}')" class="flex flex-col items-center gap-3 p-4 rounded-3xl border-2 border-slate-100 bg-slate-50 hover:border-brand-blue hover:bg-white hover:shadow-xl transition-all group"><div class="w-12 h-12 rounded-2xl bg-white border border-slate-100 flex items-center justify-center text-slate-400 group-hover:text-brand-blue transition-all shadow-sm"><span class="material-symbols-outlined text-2xl">${opt.icon}</span></div><span class="font-bold text-slate-700 group-hover:text-brand-dark text-[10px] md:text-[11px] leading-tight text-center">${opt.label}</span></button>`).join('');
            return `<div class="text-center relative"><p class="text-[10px] font-bold text-slate-400 uppercase tracking-[0.2em] mb-4 text-center m-0 p-0">${t('personalizing')} • ${state.surveyIndex + 1}/${questions.length}</p><h3 class="text-xl md:text-2xl font-bold font-hess text-brand-dark mb-8 leading-tight px-2 text-center m-0 p-0">${q.label}</h3><div class="grid gap-3 ${gridCols}">${optionsHtml}</div><div class="mt-8"><button onclick="Actions.skipSurvey()" class="text-[10px] font-bold text-slate-400 uppercase tracking-widest hover:text-brand-dark transition-colors">${t('skipSurvey')}</button></div></div>`;
          
          case 5: 
          
            return `<div class="text-center py-10 relative"><div class="w-20 h-20 bg-brand-green rounded-full flex items-center justify-center mx-auto mb-8 shadow-xl shadow-green-500/20"><span class="material-symbols-outlined text-white text-4xl">check_circle</span></div><h2 class="text-3xl font-black font-hess text-brand-dark mb-4 uppercase italic leading-none text-center m-0 p-0">${t('accessGranted')}</h2><p class="text-slate-500 font-medium text-lg mb-10 leading-relaxed px-4 italic text-balance text-center m-0 p-0 mt-2">${t('syncing')}</p><div class="flex flex-col items-center gap-4"><div class="flex justify-center items-center mt-4"><dotlottie-player src="https://cdn.shopify.com/s/files/1/1021/9561/files/Loading_GH.json?v=1775340924" background="transparent" speed="1" style="width: 80px; height: 80px;" loop autoplay></dotlottie-player></div></div></div>`;
          
          default:
            return '';
        }
      };

      const showBackBtn = state.step > 1 && state.step < 4 && !state.isCheckingMembership;
      return `<div class="relative w-full z-[100] min-h-screen pt-8 pb-32 px-4 bg-slate-100"><div class="max-w-2xl mx-auto bg-white w-full rounded-[48px] shadow-xl border border-slate-200 relative z-10 overflow-hidden flex flex-col"><div class="p-6 md:p-12">${state.step < 5 ? `<div class="flex justify-end mb-4"><button onclick="Actions.closeModal()" class="text-slate-300 hover:text-brand-dark transition-colors flex items-center gap-1"><span class="text-[10px] font-bold uppercase tracking-widest mr-1">${t('cancel')}</span><span class="material-symbols-outlined">close</span></button></div>` : ''}${state.step < 5 && !state.isCheckingMembership ? StepIndicator() : ''}<div class="mt-4">${renderModalContent()}</div>${showBackBtn ? `<button onclick="Actions.backStep()" class="w-full mt-8 mb-6 text-center text-[10px] font-bold text-slate-300 uppercase tracking-widest hover:text-brand-dark transition-colors flex items-center justify-center gap-2"><span class="material-symbols-outlined text-sm">arrow_back</span> ${t('returnStep')}</button>` : ''}</div></div></div>`;
    };

    const render = () => {
      const mainContainer = document.getElementById('main-view');
      const modalContainer = document.getElementById('modal-view');
      
      // The indestructible mobile sticky portal
      let portal = document.getElementById('gh-sticky-portal');
      if (!portal) {
        portal = document.createElement('div');
        portal.id = 'gh-sticky-portal';
        portal.style.position = 'fixed';
        portal.style.bottom = '0';
        portal.style.left = '0';
        portal.style.width = '100%';
        portal.style.zIndex = '2147483647';
        portal.style.transform = 'translateZ(0)'; 
        portal.style.webkitTransform = 'translateZ(0)';
        portal.innerHTML = `<div class="font-poppins"><div id="sticky-view-detached"></div></div>`;
        document.body.appendChild(portal);
      }
      
      const stickyContainer = document.getElementById('sticky-view-detached');

      mainContainer.style.display = state.isModalOpen ? 'none' : 'block';
      if (portal) portal.style.display = state.isModalOpen ? 'none' : 'block'; 

      const newMainHtml = renderMainContentHtml();
      if (mainContainer.innerHTML !== newMainHtml) {
        mainContainer.innerHTML = newMainHtml;
      }

      if (state.isModalOpen) {
        const newModalHtml = renderModalHtml();
        
        // THE FIX: Protect the active Clerk form from being wiped by background data refreshes
        const clerkBoxId = state.step === 1 ? 'clerk-signup-container' : (state.step === 2 ? 'clerk-org-container' : null);
        const clerkBox = clerkBoxId ? document.getElementById(clerkBoxId) : null;
        const isClerkActive = clerkBox && clerkBox.innerHTML.trim() !== '';

        if (modalContainer.innerHTML !== newModalHtml) {
          // If Clerk is active and we haven't changed steps, DO NOT wipe the HTML. Let them type!
          if (isClerkActive && !state.isCheckingMembership && state.step === window._lastRenderedStep) {
             // Form protected.
          } else {
             modalContainer.innerHTML = newModalHtml;
             window._lastRenderedStep = state.step;
          }
        }
        
        setTimeout(() => {
          if (state.step === 1 && !state.isCheckingMembership) mountClerkComponent();
          if (state.step === 2 && state.view === 'group' && !state.isCheckingMembership) mountClerkOrgComponent();
        }, 50);
      } else {
        modalContainer.innerHTML = '';
      }
      
      if (stickyContainer) stickyContainer.innerHTML = renderStickyFooterHtml();
    };

    // ========================================================================
    // APP INIT
    // ========================================================================
    const initApp = async () => {
render();
      
      //  THE FIX: Give the interval its own private tracking variable
      let intervalLastUserId = null; 
      let previousUserId = null; // Left intact for the listener
      authTransitionInProgress = false;

      setInterval(() => {
        if (!state.isClerkLoaded || state.isLoggingOut || authTransitionInProgress || !window.Clerk) return;
        
        const currentUserId = window.Clerk.user ? window.Clerk.user.id : null;
        
        // Safely detects a brand new login, even if Safari paused the browser
        if (currentUserId && currentUserId !== intervalLastUserId) {
          
          authTransitionInProgress = true;
          intervalLastUserId = currentUserId; // Update private tracker

          const clerkSignupBox = document.getElementById('clerk-signup-container');
          if (clerkSignupBox) clerkSignupBox.style.display = 'none';

          if (state.isModalOpen && state.step === 1) {
            let nextStep = (state.view === 'group' && !hasActiveOrganization()) ? 2 : 3;
            
            updateStateSilent('step', nextStep);
            
            try {
              const currentUrl = new URL(window.location.href);
              currentUrl.searchParams.set('step', nextStep);
              window.history.replaceState(null, '', currentUrl.toString());
            } catch(e) {}
            
            setState({ isCheckingMembership: true, step: nextStep });
          }
          
          refreshMembershipStatus().finally(() => {
            authTransitionInProgress = false;
            // If still on step 1 after membership check, advance to next step
            if (state.isModalOpen && state.step === 1) {
              const nextStep = (state.view === 'group' && !hasActiveOrganization()) ? 2 : 3;
              setState({ isCheckingMembership: false, step: nextStep });
            } else {
              setState({ isCheckingMembership: false });
            }
          });

        } else if (!currentUserId) {
          // Reset if they log out
          intervalLastUserId = null;
        }
        }, 50);

      const setupClerkListeners = () => {
        if (typeof window.Clerk.addListener === 'function') {
          window.Clerk.addListener(async ({ user, organization }) => {
            if (state.isLoggingOut || authTransitionInProgress) return;
            
            const currentUserId = user ? user.id : null;
            previousUserId = currentUserId;

            if (!user) { 
              if (typeof Purchases !== 'undefined' && typeof Purchases.Purchases !== 'undefined') {
                try { await Purchases.Purchases.getSharedInstance().logOut(); } catch(e){}
              }
              setState({ hasProEntitlement: false, membershipPlan: null, hasActiveIndividual: false, hasActiveGroup: false, isCheckingMembership: false }); 
              return; 
            }
            if (organization || hasActiveOrganization()) { 
              await syncClerkStateAfterOrganizationChange(); 
              return; 
            }
            await refreshMembershipStatus();
          });
        }
      };

      // 1. URL params take highest priority (shared links, email campaigns, etc.)
      const params = new URLSearchParams(window.location.search);
      const urlPlanType = params.get('planType');
      const urlPlan = params.get('plan');
      const urlPeriod = params.get('period');
      const urlStep = params.get('step');

      if (urlPlanType && ['individual', 'group'].includes(urlPlanType)) {
        updateStateSilent('view', urlPlanType);
        updateStateSilent('selectedPlan', urlPlan || (urlPlanType === 'individual' ? 'annual' : 'group_family'));
      }
      if (urlPeriod && ['monthly', 'annual'].includes(urlPeriod)) {
        updateStateSilent('billingPeriod', urlPeriod);
      }
      if (urlStep && !isNaN(parseInt(urlStep))) {
        updateStateSilent('step', parseInt(urlStep));
        updateStateSilent('isModalOpen', true);
      }

      // 2. sessionStorage fills in only what URL didn't specify
      if (!urlPlanType) {
        try {
          const saved = sessionStorage.getItem('gh_checkout_intent');
          if (saved) {
            const d = JSON.parse(saved);
            if (d.view) updateStateSilent('view', d.view);
            if (d.plan) updateStateSilent('selectedPlan', d.plan);
            if (d.period) updateStateSilent('billingPeriod', d.period);
          }
        } catch (e) {}
      }
      
    if (typeof Purchases !== 'undefined') {
  try {
    let rcInstance = null;
    try { rcInstance = Purchases.Purchases.getSharedInstance(); } catch(e) {}
    if (!rcInstance) {
      Purchases.Purchases.configure(REVENUECAT_PUBLIC_KEY, '$RCAnonymousID:' + Math.random().toString(36).slice(2));
    }
    await updatePricesFromRevenueCat();
    render();
  } catch (e) { console.warn('[GH] RC init failed:', e); }
}
    const loadClerkAndInit = async () => {
  await window.Clerk.load({
    ui: { ClerkUI: window.__internal_ClerkUICtor },
    localization: {
      createOrganization: {
        title: 'Create Group',
        formButtonSubmit: 'Create Group',
      },
    },
    routerPush: (to) => {
      const scrollY = window.scrollY;
      window.history.pushState(null, '', to);
      if (document.activeElement && document.activeElement.closest('.cl-rootBox')) {
        window.scrollTo(0, scrollY);
      }
    },
    routerReplace: (to) => window.history.replaceState(null, '', to)
  });
  if (state.isModalOpen && state.step === 1 && window.Clerk.user) {
    let nextStep = state.view === 'group' && !hasActiveOrganization() ? 2 : 3;
    updateStateSilent('step', nextStep);
    try {
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set('step', nextStep);
      window.history.replaceState(null, '', currentUrl.toString());
    } catch(e) {}
  }

  previousUserId = window.Clerk.user ? window.Clerk.user.id : null;
  setupClerkListeners();
  await refreshMembershipStatus();

  state.isClerkLoaded = true;
  render();
};

if (window.Clerk) { await loadClerkAndInit(); }
else {
  const script = document.createElement('script');
  script.setAttribute('data-clerk-publishable-key', CLERK_PUBLISHABLE_KEY);
  script.src = 'https://clerk.grouphiit.com/npm/@clerk/clerk-js@6/dist/clerk.browser.js';
  script.onload = loadClerkAndInit;
  document.head.appendChild(script);
}

// ── FALLBACK: If Clerk never loads, show pricing tabs after 6 seconds ──
setTimeout(() => {
  if (!state.isClerkLoaded) {
    console.warn('[GH] Clerk load timeout — showing pricing tabs for logged-out user');
    state.isClerkLoaded = true;
    render();
  }
}, 6000);
    };

   if (document.readyState === 'loading') { 
  document.addEventListener('DOMContentLoaded', initApp); 
} else { 
  initApp(); 
}

    window.addEventListener('pageshow', (event) => {
      if (event.persisted) {
        setState({ isCheckingMembership: false, isRedirecting: false });
        try {
          const currentUrl = new URL(window.location.href);
          if (currentUrl.searchParams.has('step')) {
            currentUrl.searchParams.delete('step');
            currentUrl.searchParams.delete('planType');
            window.history.replaceState(null, '', currentUrl.toString());
            setState({ isModalOpen: false });
          }
        } catch (e) {}
        refreshMembershipStatus();
      }
    });

    window.Actions = Actions;
    window.updateStateSilent = updateStateSilent;
  })();
